<template>
    <el-card class="box-card2">
        <div slot="header" class="clearfix" v-loading="loading">
            <span class="ptitle right-20">科目详情</span>
            <span v-if="subjectTypeId != 0">
                <el-button
                    class="pull-right left-10"
                    type="primary"
                    icon="el-icon-check"
                    size="mini"
                    @click="save"
                    v-if="
                        isGranted('Pages.SubjectDetails.Create') ||
                        isGranted('Pages.SubjectDetails.Edit')
                    "
                    >保存</el-button
                >
                <!-- <el-button class="pull-right right-20" icon="el-icon-sort" size="mini" @click="getSubjectFieldRow" >提取选项数据</el-button>-->
                <!-- <el-button class="pull-right" icon="el-icon-plus" size="mini" @click="setFormula" v-if="isGranted('Pages.SubjectDetails.Create') && moduleMark=='SCM'" >新增科目公式</el-button> -->
                <el-button
                    class="pull-right"
                    icon="el-icon-plus"
                    size="mini"
                    @click="addRow"
                    v-if="isGranted('Pages.SubjectDetails.Create')"
                    >新增科目详情</el-button
                >
                <el-button
                    class="pull-right"
                    icon="el-icon-document"
                    size="mini"
                    @click="quickCopy"
                    v-if="
                        isGranted('Pages.SubjectDetails.Create') && isMultiOrg
                    "
                    >快速复制</el-button
                >
                <el-button
                    class="pull-right"
                    icon="el-icon-delete"
                    size="mini"
                    @click="clearFilter"
                    >清除过滤器</el-button
                >
                <el-button
                    class="pull-right"
                    size="mini"
                    icon="el-icon-upload"
                    @click="importExcel"
                    >导入导出</el-button
                >
                <el-button
                    @click="showField"
                    class="pull-right"
                    size="mini"
                    icon="el-icon-tickets"
                    v-if="
                        detailParamItems.length > 1 ||
                        subjectType == '门店收入科目'
                    "
                    >显示/隐藏字段</el-button
                >
                <el-button
                    @click="checkComplate"
                    class="pull-right"
                    size="mini"
                    icon="el-icon-bell"
                    v-if="
                        subjectType == '门店收银方式科目' ||
                        subjectType == '门店收银方式'
                    "
                    >结算方式检测</el-button
                >
                <!-- <el-button
          @click="checkInComeComplate"
          class="pull-right"
          size="mini"
          icon="el-icon-bell"
          v-if="subjectType == '门店收入科目' || subjectType == '门店收入'"
          >收入类型检测</el-button
        > -->
                <el-button
                    @click="checkSubjectComplate"
                    class="pull-right"
                    size="mini"
                    icon="el-icon-bell"
                    >科目检测</el-button
                >
                <el-button
                    class="pull-right"
                    icon="el-icon-tickets"
                    size="mini"
                    @click="SubjectAllCoverage"
                    :disabled="!allCoverageVisiable"
                    v-if="
                        isGranted('Pages.SubjectDetails.AllCoverage') &&
                        isMultiOrg
                    "
                    >科目整体覆盖</el-button
                >
            </span>
        </div>
        <!-- <el-row v-if="moduleMark=='SCM'">
      <span class="subtitle">科目公式信息</span>
    </el-row>
    <el-row v-if="moduleMark=='SCM'">
      <el-table
        :data="formulaData"
        :height="formulaheight"
        size="mini"
        border
        :highlight-current-row="true"
        class="toggletable"
        :header-cell-class-name="cell"
      >
        <el-table-column type="index" label="序号" width="50" fixed></el-table-column>
        <el-table-column label="删除" width="50" fixed>
          <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                @click="deleteFormulaRow(scope.$index, scope.row.id)"
                v-if="isGranted('Pages.SubjectDetails.Delete')"
              ></el-button>
          </template>
        </el-table-column>

        <el-table-column :label="subjectTypeCode" prop="oppositeSubjectID" min-width="126" fixed>
          <template slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              class
              @click="openSelect(scope.$index, '会计科目', true)"
            >选择</el-button>
            {{scope.row.oppositeSubjectID}}
          </template>
        </el-table-column>
        <el-table-column :label="subjectTypeName" prop="oppositeSubjectName" min-width="126" fixed></el-table-column>
        <el-table-column label="辅助核算" prop="auxiliaryAccount" min-width="80" fixed></el-table-column>

        <el-table-column
          label="红蓝字"
          width="80"
          prop="isRedMark"
          v-if="moduleMark!='CRM'"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isRedMark"
              active-color="#f56c6c"
              inactive-color="#409EFF"
              @change="redmarkChange(scope.row.id, scope.row.isRedMark)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="借贷方"
          width="80"
          prop="isCredit"
          v-if="moduleMark!='CRM'"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isCredit"
              active-color="#f56c6c"
              inactive-color="#409EFF"
              @change="isCreditChange(scope.row.id, scope.row.isCredit)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="cloudSupplyAmount"
          label="金额类型"
          v-if="moduleMark=='SCM'"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
                v-model="scope.row.cloudSupplyAmount"
                placeholder="请选择金额类型"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in cloudSupplyAmounts"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <span>{{scope.row.cloudSupplyAmount}}</span>
          </template>
        </el-table-column>

        <template v-for="(item,index) in detailParamItems" >
          <el-table-column :label="item.fieldName+'字段'" min-width="160">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row[item.fieldName+'字段']"
                placeholder="请选择字段"
                size="mini"
                clearable
                v-if="moduleMark=='POS'"
                class="width120 floatleft"
              >
                <el-option value="ID">ID</el-option>
                <el-option value="编码">编码</el-option>
                <el-option value="名称">名称</el-option>
              </el-select>
              <el-select
                v-model="scope.row[item.fieldName+'字段']"
                placeholder="请选择字段"
                size="mini"
                clearable
                v-else
                class="width120 floatleft"
              >
                <el-option value="编码">编码</el-option>
                <el-option value="名称">名称</el-option>
              </el-select>

              <el-select
                v-model="scope.row[item.fieldName+'操作']"
                placeholder="请选择操作"
                size="mini"
                clearable
                class="width120 floatleft"
              >
                <el-option v-for="item in formulaOperData" :key="item" :label="item" :value="item"></el-option>
              </el-select>

              <el-input
                v-model="scope.row[item.fieldName+'值']"
                size="mini"
                placeholder="请输入公式值"
                class="width120 floatleft"
              ></el-input>

              <span
                v-if="scope.row[item.fieldName+'字段'] && scope.row[item.fieldName+'操作'] && scope.row[item.fieldName+'值']"
              >{{item.fieldName}}：{{scope.row[item.fieldName+'字段']}} -> {{scope.row[item.fieldName+'操作']}} -> {{scope.row[item.fieldName+'值']}}</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </el-row>

    <el-row v-if="moduleMark=='SCM'">
      <span class="subtitle">科目详情信息</span>
    </el-row>-->
        <el-row id="el-row">
            <vxe-tooltip ref="xTip"></vxe-tooltip>
            <vxe-table
                @checkbox-change="selectChangeEvent"
                @checkbox-all="selectAllEvent"
                class="tableClass"
                v-if="tableVisible"
                ref="detail"
                id="out-table"
                size="mini"
                :data="tableData"
                :checkbox-config="{
                    trigger: 'cell',
                    highlight: true,
                    range: true
                }"
                :cell-style="cellStyleVxe"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
                :height="subjectTypeId == 0 ? defaultheight : infoheight"
                header-cell-class-name="headercell"
                cell-class-name="cellborder"
                :edit-rules="validRules"
                @cell-mouseenter="cellMouseenterEvent"
                @cell-mouseleave="cellMouseleaveEvent"
                border
                show-overflow
                stripe
                highlight-current-row
                highlight-hover-row
                resizable
            >
                <vxe-table-column
                    type="seq"
                    width="45"
                    fixed="left"
                ></vxe-table-column>
                <vxe-table-column
                    type="checkbox"
                    width="36"
                    fixed="left"
                ></vxe-table-column>
                <vxe-table-column
                    style="white-space: nowrap"
                    field="oppositeSubjectID"
                    :title="subjectTypeCode"
                    :edit-render="{ name: 'input' }"
                    sortable
                    min-width="180"
                    fixed="left"
                >
                    <template v-slot:edit="{ row }" style="white-space: nowrap">
                        <el-button
                            type="text"
                            class="floatleft"
                            size="mini"
                            @click="copyTo(row.index, 'oppositeSubject')"
                            v-if="cancopyTo(row.index, 'oppositeSubjectID')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="floatleft"
                            @click="copyLast(row.index, 'oppositeSubject')"
                            v-if="cancopylast(row.index, 'oppositeSubjectID')"
                            >同上</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class
                            @click="openSelect(row.index, '会计科目', false)"
                            >选择</el-button
                        >
                        {{ row.oppositeSubjectID }}
                    </template>
                    <template v-slot="{ row }">{{
                        row.oppositeSubjectID
                    }}</template>
                </vxe-table-column>

                <vxe-table-column
                    :title="subjectTypeName"
                    field="oppositeSubjectName"
                    sortable
                    min-width="170"
                    fixed="left"
                    :filters="[{ data: { vals: [], sVal: '' } }]"
                    :filter-render="{ name: 'FilterContent' }"
                ></vxe-table-column>

                <vxe-table-column
                    title="辅助核算"
                    field="auxiliaryAccount"
                    sortable
                    width="100"
                    fixed="left"
                ></vxe-table-column>
                <vxe-table-column
                    title="红蓝字"
                    width="80"
                    field="isRedMark"
                    v-if="
                        isGranted('Pages.SubjectDetails.Create') ||
                        isGranted('Pages.SubjectDetails.Delete')
                    "
                    sortable
                >
                    <template v-slot="{ row }">
                        <el-switch
                            v-model="row.isRedMark"
                            active-color="#f56c6c"
                            inactive-color="#409EFF"
                            @change="redmarkChange(row.id, row.isRedMark)"
                        ></el-switch>
                    </template>
                </vxe-table-column>
                <vxe-table-column
                    title="借贷方"
                    width="80"
                    field="isCredit"
                    v-if="
                        isGranted('Pages.SubjectDetails.Create') ||
                        isGranted('Pages.SubjectDetails.Delete')
                    "
                    sortable
                >
                    <template v-slot="{ row }">
                        <el-switch
                            v-model="row.isCredit"
                            active-color="#f56c6c"
                            inactive-color="#409EFF"
                            @change="isCreditChange(row.id, row.isCredit)"
                        ></el-switch>
                    </template>
                </vxe-table-column>

                <vxe-table-column
                    field="cloudSupplyAmount"
                    title="金额类型"
                    :edit-render="{ name: 'select', options: scm8Amounts }"
                    :filters="[{ data: { vals: [], sVal: '' } }]"
                    :filter-render="{ name: 'FilterContent' }"
                    v-if="
                        (isGranted('Pages.SubjectDetails.Create') ||
                            isGranted('Pages.SubjectDetails.Delete')) &&
                        moduleMark == 'SCM8'
                    "
                    sortable
                    width="200"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            class="floatleft myshowup"
                            size="mini"
                            @click="copyTo(row.index, 'cloudSupplyAmount')"
                            v-if="cancopyTo(row.index, 'cloudSupplyAmount')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="myshowup floatleft"
                            @click="copyLast(row.index, 'cloudSupplyAmount')"
                            v-if="cancopylast(row.index, 'cloudSupplyAmount')"
                            >同上</el-button
                        >
                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                        >
                            <option
                                :value="item"
                                v-for="item in scm8Amounts"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </template>
                    <template v-slot="{ row }">{{
                        row.cloudSupplyAmount
                    }}</template>
                </vxe-table-column>

                <vxe-table-column
                    field="cloudSupplyAmount"
                    title="金额类型"
                    :edit-render="{
                        name: 'select',
                        options: cloudSupplyAmounts
                    }"
                    :filters="[{ data: { vals: [], sVal: '' } }]"
                    :filter-render="{ name: 'FilterContent' }"
                    v-if="
                        (isGranted('Pages.SubjectDetails.Create') ||
                            isGranted('Pages.SubjectDetails.Delete')) &&
                        (moduleMark == 'SCM' || moduleMark == 'SaiHu')
                    "
                    sortable
                    width="200"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            class="floatleft myshowup"
                            size="mini"
                            @click="copyTo(row.index, 'cloudSupplyAmount')"
                            v-if="cancopyTo(row.index, 'cloudSupplyAmount')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="myshowup floatleft"
                            @click="copyLast(row.index, 'cloudSupplyAmount')"
                            v-if="cancopylast(row.index, 'cloudSupplyAmount')"
                            >同上</el-button
                        >

                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                            v-if="
                                row['收发类别名称'] == '组合成品入库单' ||
                                row['收发类别名称'] == '组合配料出库单'
                            "
                        >
                            <option
                                :value="item"
                                v-for="item in cloudSupplyAmountForZHCPRKD"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>

                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                            v-if="
                                subjectType != '收付款科目' &&
                                subjectType != '收付款对方科目' &&
                                row['收发类别名称'] != '组合成品入库单' &&
                                row['收发类别名称'] != '组合配料出库单'
                            "
                        >
                            <option
                                :value="item"
                                v-for="item in cloudSupplyAmounts"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>

                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                            v-if="
                                subjectType == '收付款科目' ||
                                subjectType == '收付款对方科目'
                            "
                        >
                            <option
                                :value="item"
                                v-for="item in cloudSupplyAmountForSSSF"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </template>
                    <template v-slot="{ row }">{{
                        row.cloudSupplyAmount
                    }}</template>
                </vxe-table-column>

                <vxe-table-column
                    field="cloudSupplyAmount"
                    title="金额类型"
                    :edit-render="{ name: 'select', options: Z5CloudAmounts }"
                    v-if="
                        (isGranted('Pages.SubjectDetails.Create') ||
                            isGranted('Pages.SubjectDetails.Delete')) &&
                        moduleMark == 'Z5'
                    "
                    sortable
                    width="200"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            class="floatleft myshowup"
                            size="mini"
                            @click="copyTo(row.index, 'cloudSupplyAmount')"
                            v-if="cancopyTo(row.index, 'cloudSupplyAmount')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="myshowup floatleft"
                            @click="copyLast(row.index, 'cloudSupplyAmount')"
                            v-if="cancopylast(row.index, 'cloudSupplyAmount')"
                            >同上</el-button
                        >
                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                            v-if="row['收发类别名称'] != '应付单'"
                        >
                            <option
                                :value="item"
                                v-for="item in Z5CloudAmounts"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>
                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                            v-if="row['收发类别名称'] == '应付单'"
                        >
                            <option
                                :value="item"
                                v-for="item in Z5CloudAmountForPay"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </template>
                    <template v-slot="{ row }">{{
                        row.cloudSupplyAmount
                    }}</template>
                </vxe-table-column>

                <vxe-table-column
                    field="cloudSupplyAmount"
                    title="金额类型"
                    :edit-render="{ name: 'select', options: CrmAmounts }"
                    :filters="[{ data: { vals: [], sVal: '' } }]"
                    :filter-render="{ name: 'FilterContent' }"
                    v-if="
                        (isGranted('Pages.SubjectDetails.Create') ||
                            isGranted('Pages.SubjectDetails.Delete')) &&
                        moduleMark == 'CRM'
                    "
                    sortable
                    width="140"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            class="floatleft myshowup"
                            size="mini"
                            @click="copyTo(row.index, 'cloudSupplyAmount')"
                            v-if="cancopyTo(row.index, 'cloudSupplyAmount')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="myshowup floatleft"
                            @click="copyLast(row.index, 'cloudSupplyAmount')"
                            v-if="cancopylast(row.index, 'cloudSupplyAmount')"
                            >同上</el-button
                        >
                        <select
                            class="cloudSupplySelect"
                            v-model="row.cloudSupplyAmount"
                            placeholder="请选择金额类型"
                        >
                            <option
                                :value="item"
                                v-for="item in CrmAmounts"
                                class="cloudSupplyOption"
                            >
                                {{ item }}
                            </option>
                        </select>
                    </template>
                    <template v-slot="{ row }">{{
                        row.cloudSupplyAmount
                    }}</template>
                </vxe-table-column>

                <vxe-table-column
                    field="otherOrganType"
                    title="对方机构属性"
                    :edit-render="{ name: 'select', options: OrgTypes }"
                    :filters="[{ data: { vals: [], sVal: '' } }]"
                    :filter-render="{ name: 'FilterContent' }"
                    v-if="
                        (isGranted('Pages.SubjectDetails.Create') ||
                            isGranted('Pages.SubjectDetails.Delete')) &&
                        moduleMark == 'SCM8'
                    "
                    sortable
                    width="200"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            class="floatleft myshowup"
                            size="mini"
                            @click="copyTo(row.index, 'otherOrganType')"
                            v-if="cancopyTo(row.index, 'otherOrganType')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="myshowup floatleft"
                            @click="copyLast(row.index, 'otherOrganType')"
                            v-if="cancopylast(row.index, 'otherOrganType')"
                            >同上</el-button
                        >
                        <select
                            ref="otherOrganType"
                            class="cloudSupplySelect"
                            v-model="row.otherOrganType"
                            placeholder="请选择机构属性"
                        >
                            <option
                                :value="item.value + '~' + item.label"
                                :key="index"
                                :label="item.label"
                                v-for="(item, index) in OrgTypes"
                                class="cloudSupplyOption"
                            >
                                {{ item.label }}
                            </option>
                        </select>
                    </template>
                    <template v-slot="{ row }">{{
                        getlabel(row.otherOrganType)
                    }}</template>
                </vxe-table-column>

                <template
                    v-for="(item, index) in detailParamItems"
                    v-if="isshowField(item.fieldName)"
                >
                    <vxe-table-column
                        :field="item.fieldName"
                        :title="
                            moduleMark == 'POS'
                                ? item.fieldName
                                : item.fieldName + '编码'
                        "
                        :edit-render="{ name: 'input' }"
                        v-if="item.fieldType == 'selectOption'"
                        sortable
                        min-width="160"
                        class="tableColumn"
                    >
                        <template v-slot:edit="{ row }">
                            <el-button
                                type="text"
                                class="floatleft myshowup"
                                size="mini"
                                @click="copyTo(row.index, item.fieldName)"
                                v-if="cancopyTo(row.index, item.fieldName)"
                                >向下复制</el-button
                            >
                            <el-button
                                type="text"
                                size="mini"
                                class="myshowup floatleft"
                                @click="copyLast(row.index, item.fieldName)"
                                v-if="cancopylast(row.index, item.fieldName)"
                                >同上</el-button
                            >
                            <el-button
                                type="text"
                                size="mini"
                                class="myshowup"
                                v-if="
                                    item.fieldName != '收发类别' &&
                                    item.fieldName != '业务类型' &&
                                    item.fieldName != '品项大类' &&
                                    item.fieldName != '品项小类'
                                "
                                @click="
                                    openSelect(row.index, item.fieldName, false)
                                "
                                >选择</el-button
                            >
                            <el-button
                                type="text"
                                size="mini"
                                class="myshowup"
                                v-else
                                @click="
                                    openMutilSelect(
                                        row.index,
                                        item.fieldName,
                                        false,
                                        row[item.fieldName]
                                    )
                                "
                                >选择</el-button
                            >
                            {{ row[item.fieldName] }}
                        </template>
                        <template v-slot="{ row }">{{
                            row[item.fieldName]
                        }}</template>
                    </vxe-table-column>

                    <vxe-table-column
                        :title="item.fieldName + '编码'"
                        :field="item.fieldName + '编码'"
                        v-if="
                            item.fieldType == 'selectOption' &&
                            moduleMark == 'POS'
                        "
                        sortable
                        min-width="150"
                    ></vxe-table-column>

                    <vxe-table-column
                        :title="item.fieldName + '名称'"
                        :field="item.fieldName + '名称'"
                        v-if="item.fieldType == 'selectOption'"
                        :filters="[{ data: { vals: [], sVal: '' } }]"
                        :filter-render="{ name: 'FilterContent' }"
                        sortable
                        min-width="170"
                    ></vxe-table-column>

                    <vxe-table-column
                        field="amountSource"
                        title="金额来源"
                        :edit-render="{ name: 'select', options: AmountList }"
                        :filters="[{ data: { vals: [], sVal: '' } }]"
                        :filter-render="{ name: 'FilterContent' }"
                        v-if="
                            item.fieldName == '门店收银方式' ||
                            item.fieldName == '门店收入类型'
                        "
                        sortable
                        width="200"
                    >
                        <template v-slot:edit="{ row }">
                            <el-button
                                type="text"
                                class="floatleft"
                                size="mini"
                                @click="copyTo(row.index, 'amountSource')"
                                v-if="cancopyTo(row.index, 'amountSource')"
                                >向下复制</el-button
                            >
                            <el-button
                                type="text"
                                size="mini"
                                class="floatleft"
                                @click="copyLast(row.index, 'amountSource')"
                                v-if="cancopylast(row.index, 'amountSource')"
                                >同上</el-button
                            >
                            <select
                                class="cloudSupplySelect"
                                v-model="row.amountSource"
                                placeholder="请选择金额类型"
                                v-if="
                                    item.fieldName == '门店收银方式' &&
                                    row[item.fieldName + '编码'] != null &&
                                    row[item.fieldName + '编码'] != undefined &&
                                    row[item.fieldName + '编码'] != ''
                                "
                            >
                                <option
                                    :value="item"
                                    v-for="item in AmountList"
                                    class="cloudSupplyOption"
                                >
                                    {{ item }}
                                </option>
                            </select>
                            <select
                                class="cloudSupplySelect"
                                v-model="row.amountSource"
                                placeholder="请选择金额类型"
                                v-if="
                                    item.fieldName == '门店收银方式' &&
                                    (row[item.fieldName + '编码'] == null ||
                                        row[item.fieldName + '编码'] ==
                                            undefined ||
                                        row[item.fieldName + '编码'] == '')
                                "
                            >
                                <option
                                    :value="item"
                                    v-for="item in AmountListForEmpty"
                                    class="cloudSupplyOption"
                                >
                                    {{ item }}
                                </option>
                            </select>
                            <select
                                class="cloudSupplySelect"
                                v-model="row.amountSource"
                                placeholder="请选择金额类型"
                                v-if="item.fieldName == '门店收入类型'"
                            >
                                <option
                                    :value="item"
                                    v-for="item in AmountListForIncome"
                                    class="cloudSupplyOption"
                                >
                                    {{ item }}
                                </option>
                            </select>
                        </template>
                        <template v-slot="{ row }">{{
                            row.amountSource
                        }}</template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="amountSource"
                        title="金额来源"
                        :edit-render="{
                            name: 'select',
                            options: AmountListForYJAndHK
                        }"
                        :filters="[{ data: { vals: [], sVal: '' } }]"
                        :filter-render="{ name: 'FilterContent' }"
                        v-if="
                            item.fieldName == '支付方式' ||
                            item.fieldName == '应收'
                        "
                        sortable
                        width="200"
                    >
                        <template v-slot:edit="{ row }">
                            <el-button
                                type="text"
                                class="floatleft"
                                size="mini"
                                @click="copyTo(row.index, 'amountSource')"
                                v-if="cancopyTo(row.index, 'amountSource')"
                                >向下复制</el-button
                            >
                            <el-button
                                type="text"
                                size="mini"
                                class="floatleft"
                                @click="copyLast(row.index, 'amountSource')"
                                v-if="cancopylast(row.index, 'amountSource')"
                                >同上</el-button
                            >
                            <select
                                class="cloudSupplySelect"
                                v-model="row.amountSource"
                                placeholder="请选择金额类型"
                            >
                                <option
                                    :value="item"
                                    v-for="item in AmountListForYJAndHK"
                                    class="cloudSupplyOption"
                                >
                                    {{ item }}
                                </option>
                            </select>
                        </template>
                        <template v-slot="{ row }">{{
                            row.amountSource
                        }}</template>
                    </vxe-table-column>
                </template>

                <vxe-table-column
                    field="feeTax"
                    title="税率%"
                    :edit-render="{ name: 'input' }"
                    v-if="
                        moduleMark == 'POS' ||
                        subjectType == '卡升级销项税科目' ||
                        subjectType == '卡升级预收科目' ||
                        subjectType == '收入科目' ||
                        subjectType == '销项税科目'
                    "
                    width="200"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            class="floatleft"
                            size="mini"
                            @click="copyTo(row.index, 'feeTax')"
                            v-if="cancopyTo(row.index, 'feeTax')"
                            >向下复制</el-button
                        >
                        <el-button
                            type="text"
                            size="mini"
                            class="floatleft"
                            @click="copyLast(row.index, 'feeTax')"
                            v-if="cancopylast(row.index, 'feeTax')"
                            >同上</el-button
                        >
                        <el-input
                            class="dialog-input-text"
                            v-model="row.feeTax"
                            type="text"
                        ></el-input>
                    </template>
                    <template v-slot="{ row }">{{ row.feeTax }}</template>
                </vxe-table-column>

                <vxe-table-column
                    field="serviceChargeStr"
                    title="手续费"
                    :edit-render="{ name: 'input' }"
                    v-if="moduleMark == 'POS'"
                    width="140"
                >
                    <template v-slot:edit="{ row }">
                        <el-button
                            type="text"
                            size="mini"
                            class="myshowup"
                            @click="openServiceCharge(row.index)"
                            >编辑</el-button
                        >
                        {{ row.serviceChargeStr }}
                    </template>
                    <template v-slot="{ row }">{{
                        row.serviceChargeStr
                    }}</template>
                </vxe-table-column>
            </vxe-table>
        </el-row>
        <el-button size="mini" type="primary" @click="batcopy"
            >批量复制</el-button
        >
        <el-button
            size="mini"
            type="danger"
            class="batchdelbutton"
            @click="batchdelete"
            >批量删除</el-button
        >
        <el-button size="mini" type="primary" @click="batred(false)"
            >批量设为蓝字</el-button
        >
        <el-button size="mini" type="danger" @click="batred(true)"
            >批量设为红字</el-button
        >
        <el-button size="mini" type="primary" @click="batisCredit(false)"
            >批量设为借方</el-button
        >
        <el-button size="mini" type="danger" @click="batisCredit(true)"
            >批量设为贷方</el-button
        >

        <el-dialog
            :visible.sync="importExcelVisible"
            title="导入导出"
            width="40%"
        >
            <el-form label-width="80px">
                <el-form-item label="导出模板">
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        type="primary"
                        @click="exportExcel('template')"
                        >导出模板</el-button
                    >
                </el-form-item>
                <el-form-item label="导出数据">
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        type="primary"
                        @click="exportExcel"
                        >导出数据</el-button
                    >
                </el-form-item>
                <el-form-item label="导入数据">
                    <el-button
                        @click="filechange"
                        size="mini"
                        type="primary"
                        icon="el-icon-upload2"
                        v-loading="filechangeloading"
                        >导入数据</el-button
                    >
                    <input
                        type="file"
                        ref="uploadExcel"
                        v-if="fileVisible"
                        v-show="false"
                        accept=".xls, .xlsx"
                        @change="importfile(this)"
                    />
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog
            title="显示/隐藏字段"
            :visible.sync="showFieldVisible"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
        >
            <el-checkbox-group
                v-model="showFields"
                :min="1"
                @change="showFieldChange"
            >
                <el-checkbox
                    v-for="item in detailParamItems"
                    :label="item.fieldName"
                    :key="item.fieldName"
                    >{{ item.fieldName }}</el-checkbox
                >
            </el-checkbox-group>
            <!-- <el-checkbox-group v-model="showFields" :min="1" size="mini" @change="showFieldChange">
        <el-checkbox-button v-for="item in detailParamItems" :label="item.fieldName" :key="item.fieldName">{{item.fieldName}}</el-checkbox-button>
      </el-checkbox-group>-->
        </el-dialog>

        <el-dialog
            title="收入类型检测"
            :visible.sync="checkInComeComplateVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-loading="checkInComeComplateLoading"
            element-loading-background="rgba(0, 0, 0, 0.1)"
        >
            检测范围：
            <el-radio-group v-model="dateInComePeriod" size="mini" class>
                <el-radio-button :label="7">近7天</el-radio-button>
                <el-radio-button :label="15">近15天</el-radio-button>
                <el-radio-button :label="30">近30天</el-radio-button>
            </el-radio-group>
            <el-button
                @click="checkInComeComplateGo"
                type="primary"
                class="left-10"
                size="mini"
                >检测</el-button
            >
            <div v-if="checkInComeComplateOver" class="margintop20">
                检测结果：
                <span v-if="unSetInComeDataEntitites.length == 0"
                    >收入类型设置正确</span
                >
                <span v-else>
                    收入类型设置不完整，未设置项如下
                    <el-button
                        @click="exportExcelforcheckInComeComplateunError"
                        size="mini"
                        class="floatright"
                        type="primary"
                        >点击导出</el-button
                    >
                    <el-table
                        :data="unSetInComeDataEntitites"
                        size="mini"
                        border
                        :highlight-current-row="true"
                        class="toggletable"
                        id="checkInComeComplateunError"
                    >
                        <el-table-column
                            label="品项编码"
                            prop="itemCode"
                        ></el-table-column>
                        <el-table-column
                            label="品项名称"
                            prop="itemName"
                        ></el-table-column>
                        <el-table-column
                            label="小类编码"
                            prop="itemClassCode"
                        ></el-table-column>
                        <el-table-column
                            label="小类名称"
                            prop="itemClassName"
                        ></el-table-column>
                        <el-table-column
                            label="大类编码"
                            prop="itemBigCode"
                        ></el-table-column>
                        <el-table-column
                            label="大类名称"
                            prop="itemBigName"
                        ></el-table-column>
                        <el-table-column
                            label="门店编码"
                            prop="storeCode"
                        ></el-table-column>
                        <el-table-column
                            label="门店名称"
                            prop="storeName"
                        ></el-table-column>
                    </el-table>
                </span>
            </div>
        </el-dialog>

        <el-dialog
            title="结算方式检测"
            :visible.sync="checkComplateVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            v-loading="checkComplateLoading"
            element-loading-background="rgba(0, 0, 0, 0.1)"
        >
            <el-form
                :model="voucherQueryModel"
                label-width="120px"
                label-position="left"
            >
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item
                            label="检测日期"
                            label-width="80px"
                            :required="true"
                        >
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right"
                                size="mini"
                                style="width: 100%"
                                @change="timeChange"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        金额类型过滤：
                        <el-select
                            v-model="amountType"
                            placeholder="选择已配置项的金额类型"
                            size="mini"
                            class="width20"
                            @change="amountChange"
                            filterable
                        >
                            <el-option
                                v-for="item in AmountTypeList"
                                :key="item"
                                :label="item"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12">
                        <el-button
                            @click="checkComplateGo"
                            type="primary"
                            class="left-10"
                            size="mini"
                            >检测</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>
            <div v-if="checkComplateOver" class="margintop20">
                检测结果：
                <span v-if="unSetDataEntitites.length == 0"
                    >结算方式设置正确</span
                >
                <span v-else>
                    结算方式设置不完整，未设置项如下
                    <!-- <el-button
            @click="exportExcelforcheckComplateunError"
            size="mini"
            class="floatright"
            type="primary"
            >点击导出</el-button
          > -->
                    <el-button
                        @click="syncUnSetEntity"
                        size="mini"
                        class="floatright"
                        type="primary"
                        >同步新增</el-button
                    >
                    <el-table
                        :data="unSetDataEntitites"
                        size="mini"
                        border
                        :highlight-current-row="true"
                        class="toggletable"
                        id="checkComplateunError"
                    >
                        <el-table-column
                            label="门店收银方式"
                            prop="paywayId"
                        ></el-table-column>
                        <el-table-column
                            label="门店收银方式编码"
                            prop="paywayCode"
                        ></el-table-column>
                        <el-table-column
                            label="门店收银方式名称"
                            prop="paywayName"
                        ></el-table-column>

                        <el-table-column
                            label="门店编码"
                            prop="storeCode"
                        ></el-table-column>
                        <el-table-column
                            label="门店名称"
                            prop="storeName"
                        ></el-table-column>
                    </el-table>
                </span>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="importExcelResultVisible"
            title="导入信息提示"
            v-loading="importExcelloading"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            共导入{{ importExcelResult.totalCount }}条数据，{{
                importExcelResult.successCount
            }}条数据校验成功，{{
                importExcelResult.errorCount
            }}条数据校验失败，失败原因如下，可以在科目详情的表格内维护
            <div style="padding: 2px">
                <span style="color: red; font-size: 16px"
                    >注:源数据中未找到餐饮数据的已不再导入，请自行检查餐饮系统的数据状态后手工调整</span
                >
            </div>
            <el-button
                @click="exportExcelforimportExcelError"
                size="mini"
                class="floatright"
                type="primary"
                >点击导出</el-button
            >
            <el-table
                :data="importExcelResult.errorEntites"
                size="mini"
                border
                :highlight-current-row="true"
                class="toggletable"
                id="importexcelerror"
            >
                <el-table-column
                    label="导入数据序号"
                    prop="rowIndex"
                    min-width="80"
                ></el-table-column>
                <el-table-column
                    label="错误项"
                    prop="errorEntityName"
                    min-width="280"
                >
                    <template slot-scope="scope">{{
                        scope.row.errorEntityName == 'oppo'
                            ? subjectType
                            : scope.row.errorEntityName
                    }}</template>
                </el-table-column>
                <el-table-column
                    label="错误项编码"
                    prop="errorEntityCode"
                    min-width="280"
                ></el-table-column>
                <el-table-column
                    label="错误项信息"
                    prop="errorMsg"
                    min-width="280"
                ></el-table-column>
            </el-table>
        </el-dialog>

        <SubjectSelect
            ref="SubjectSelect"
            @selectValue="selectValue"
            @selectValueFormula="selectValueFormula"
            @syncAddItemType="syncAddItemType"
        ></SubjectSelect>
        <SubjectMutilSelect
            ref="SubjectMutilSelect"
            @selectMutilValue="selectMutilValue"
        ></SubjectMutilSelect>
        <SubjectServiceCharge
            ref="SubjectServiceCharge"
            @backServiceCharge="backServiceCharge"
        ></SubjectServiceCharge>
        <SubjectFormula ref="SubjectFormula"></SubjectFormula>
        <SubjectQuickCopy ref="SubjectQuickCopy"></SubjectQuickCopy>
        <SubjectCheck ref="SubjectCheckStr" :Refresh="Refresh"> </SubjectCheck>
        <SubjectAllCoverage ref="SubjectAllCoverage"></SubjectAllCoverage>
    </el-card>
</template>

<script>
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import SubjectService from '../../services/voucher/SubjectService'
import SubjectSelect from '../voucherAdmin/subjectSelect'
import SubjectServiceCharge from '../voucherAdmin/subjectServiceCharge'
import SubjectFormula from '../voucherAdmin/subjectFormula'
import SubjectQuickCopy from '../voucherAdmin/subjectQuickCopy'
import SubjectAllCoverage from '../voucherAdmin/subjectAllCoverage'

import SubjectCheck from '../voucherAdmin/SubjectCheck'
import SubjectMutilSelect from '../voucherAdmin/subjectMutilSelect'
import moment from 'moment'

import { isPrimitive } from 'util'
import { parse } from 'path'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import * as Excel from 'exceljs'

import Vue from 'vue'
import VXETable from '../../../node_modules/vxe-table/'
import XEUtils from 'xe-utils'
import FilterContent from '../../components/vxe/FilterContent'
Vue.component(FilterContent.name, FilterContent)
// 创建一个支持列内容的筛选
VXETable.renderer.add('FilterContent', {
    // 不显示底部按钮，使用自定义的按钮
    isFooter: false,
    // 筛选模板
    renderFilter(h, renderOpts, params) {
        return [<filter-content params={params} />]
    },
    // 重置数据方法
    filterResetMethod({ options }) {
        options.forEach((option) => {
            option.data = { vals: [], sVal: '' }
        })
    },
    // 筛选数据方法
    filterMethod({ option, row, column }) {
        const { vals } = option.data
        let cellValue = XEUtils.get(row, column.property)
        /* eslint-disable eqeqeq */
        if (cellValue == '') {
            if (column.property == 'oppositeSubjectName') {
                cellValue = XEUtils.get(row, 'oppositeSubjectID')
            }
        } else {
            if (column.property == 'oppositeSubjectName') {
                cellValue = XEUtils.get(row, 'oppositeSubjectID')
            }
        }
        if (column.property == 'otherOrganType') {
            cellValue = cellValue.split('~')[0]
        }
        return vals.some((val) => val == cellValue)
    }
})

const defaultFormThead = []

export default {
    name: 'subject',

    components: {
        SubjectMutilSelect: SubjectMutilSelect,

        SubjectSelect: SubjectSelect,
        SubjectServiceCharge: SubjectServiceCharge,
        SubjectFormula: SubjectFormula,
        SubjectQuickCopy: SubjectQuickCopy,
        SubjectAllCoverage: SubjectAllCoverage,
        FilterContent: FilterContent,
        SubjectCheck: SubjectCheck
    },
    data() {
        return {
            curSelectedList: [],
            allCoverageVisiable: false,
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD')
            },
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            const end = start
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            var now = new Date() //当前日期
                            var nowDayOfWeek = now.getDay() //今天本周的第几天
                            var nowDay = now.getDate() //当前日
                            var nowMonth = now.getMonth() //当前月
                            var nowYear = now.getYear() //当前年
                            nowYear += nowYear < 2000 ? 1900 : 0 //
                            var start = new Date(
                                nowYear,
                                nowMonth,
                                nowDay - nowDayOfWeek - 6
                            )
                            const end = new Date(
                                nowYear,
                                nowMonth,
                                nowDay - nowDayOfWeek
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const starttime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .startOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')
                            const endtime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .endOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')

                            picker.$emit('pick', [starttime, endtime])
                        }
                    }
                ]
            },
            amountType: '全部',
            subjectTypeId: 0,
            subjectType: '会计科目',
            subjectTypeCode: '会计科目编码',
            subjectTypeName: '会计科目名称',
            detailParamItems: [],
            brandValue: '',
            accountConfInfoValue: '',
            tableData: [],
            maxindex: 0,
            loading: false,
            myshowup: true,
            moduleMark: '',
            storeValue: '',
            isMultiOrg: false,
            amountValue: '',
            AmountListForYJAndHK: [
                '已登记押金',
                '已退押金',
                '已没收押金',
                '还款金额'
            ],
            AmountList: ['', '纯收金额', '非收入金额', '实收金额'],
            AmountListFilter: [
                {
                    data: {
                        vals: [
                            { label: '纯收金额', value: '纯收金额' },
                            { label: '非收入金额', value: '非收入金额' },
                            { label: '实收金额', value: '实收金额' },
                            { label: '营业额', value: '营业额' },
                            { label: '营业收入', value: '营业收入' },

                            { label: '会员价优惠', value: '会员价优惠' },
                            { label: '促销优惠', value: '促销优惠' },
                            { label: '赠送金额', value: '赠送金额' },
                            { label: '折扣金额', value: '折扣金额' },
                            { label: '定额优惠', value: '定额优惠' },
                            { label: '抹零金额', value: '抹零金额' },
                            { label: '优惠金额合计', value: '优惠金额合计' },
                            { label: '服务费应收', value: '服务费应收' },
                            { label: '服务费实收', value: '服务费实收' },
                            { label: '服务费纯收', value: '服务费纯收' },
                            { label: '服务费非收', value: '服务费非收' }
                        ],
                        sVal: ''
                    }
                }
            ],

            AmountListForEmpty: [
                '',
                '会员价优惠',
                '促销优惠',
                '赠送金额',
                '折扣金额',
                '定额优惠',
                '抹零金额',
                '优惠金额合计',
                '服务费应收',
                '服务费实收',
                '服务费纯收',
                '服务费非收'
            ],
            AmountTypeList: ['全部', '纯收金额', '非收入金额'],
            AmountListForIncome: [
                '',
                '营业额',
                '营业收入',
                '非收金额',
                '纯收金额',
                '优惠金额合计',
                '服务费应收',
                '服务费实收',
                '服务费纯收',
                '服务费非收'
            ],
            maxheight:
                document.documentElement.clientHeight ||
                document.body.clientHeight,
            formulaheight: 0,
            infoheight:
                document.documentElement.clientHeight ||
                document.body.clientHeight - 500,
            defaultheight:
                document.documentElement.clientHeight - 304 ||
                document.body.clientHeight - 500,
            formulaData: [],
            formulaOperData: ['包含', '等于', '前缀等于', '后缀等于'],
            storeListBySameBrandId: [], //和选中门店 同一品牌的其他门店
            OrgTypes: [
                { label: '配送中心', value: '1' },
                { label: '门店', value: '2' },
                { label: '供应商', value: '5' },
                { label: '客户', value: '6' }
            ],
            scm8Amounts: [
                '成本金额',
                '含税金额',
                '税额',
                '成本金额(不含运费)',
                '含税金额(不含运费)',
                '税额(不含运费)',
                '运费',
                '非税配送金额',
                '销售/调拨税额',
                '含税配送金额'
            ],
            cloudSupplyAmounts: [
                '成本金额',
                '含税金额',
                '税额',
                '非税配送金额',
                '销售/调拨税额',
                '含税配送金额'
            ],
            cloudSupplyAmountForZHCPRKD: [
                '实际总金额',
                '实际成本金额',
                '加工费'
            ],
            cloudSupplyAmountForSSSF: [
                '应付金额',
                '实付金额',
                '优惠金额',
                '抹零金额'
            ],
            Z5CloudAmounts: [
                '成本金额',
                '含税金额',
                '税额',
                '非税配送金额',
                '销售/调拨税额',
                '含税配送金额'
            ],
            Z5CloudAmountForPay: [
                '成本差异金额',
                '发票税额',
                '非税金额',
                '发票金额',
                '其他金额'
            ],
            CrmAmounts: [
                '充值本金',
                '充值赠送',
                '退卡本金',
                '退卡赠送',
                '工本费'
            ],
            importExcelVisible: false,
            tableVisible: true,
            validRules: {
                oppositeSubjectID: [{ required: true, message: '必填项' }],
                cloudSupplyAmount: [{ required: true, message: '必填项' }],
                收发类别: [{ required: true, message: '必填项' }]
            },
            importExcelResultVisible: false,
            importExcelResult: {},
            importExcelloading: false,
            fileVisible: false,
            filechangeloading: false,

            showFieldVisible: false,
            showFields: [],

            checkComplateVisible: false,
            datePeriod: 7,
            unSetDataEntitites: [],
            checkComplateOver: false,
            checkComplateLoading: false,

            checkInComeComplateVisible: false,
            dateInComePeriod: 7,
            unSetInComeDataEntitites: [],
            checkInComeComplateOver: false,
            checkInComeComplateLoading: false
        }
    },
    methods: {
        getlabel(code) {
            if (code != '' && code != undefined) {
                let entity = this.OrgTypes.find(
                    (item) => item.value === code.split('~')[0]
                )
                if (entity != undefined) {
                    return entity.label
                }
            }
        },
        selectChangeEvent(selection) {
            if (selection.checked) {
                this.curSelectedList.push(selection.row)
            } else {
                // 取消时删除选中项
                this.curSelectedList = this.curSelectedList.filter(
                    (item) => item.id != selection.row.id
                )
            }
            if (this.curSelectedList.length == this.tableData.length) {
                this.allCoverageVisiable = true
            } else {
                this.allCoverageVisiable = false
            }
        },
        selectAllEvent({ records }) {
            this.curSelectedList = []
            if (records.length == this.tableData.length) {
                this.allCoverageVisiable = true
            } else {
                this.allCoverageVisiable = false
            }
        },

        SubjectAllCoverage() {
            const _this = this
            var selections = _this.$refs.detail.selection
            if (_this.storeListBySameBrandId.length > 0) {
                var message = ''
                var ids = []
                selections.forEach((s) => {
                    if (s.id != undefined && s.id != null && s.id != 0) {
                        ids.push(s.id)
                    } else {
                        var rowindex =
                            _this.FindRowIndexByTableDataIndex(s.index) + 1
                        message += rowindex + ','
                    }
                })
                if (message != '') {
                    message = message.substring(0, message.length - 1)
                    _this.$message({
                        message: '第' + message + '行未保存，请先保存'
                    })
                } else {
                    _this.$refs.SubjectAllCoverage.openSelect(
                        ids,
                        _this.storeListBySameBrandId,
                        _this.storeValue,
                        _this.subjectTypeId
                    )
                }
            } else {
                _this.$message({ message: '没有要复制的目标门店' })
            }
        },
        timeChange(val) {
            this.voucherQueryModel.startTime = moment(val[0]).format(
                'YYYY-MM-DD'
            )
            this.voucherQueryModel.endTime = moment(val[1]).format('YYYY-MM-DD')
        },
        filterTag({ value, row, column }) {
            return row.amountSource == value
        },
        amountChange() {},
        cellStyleVxe({ row, rowIndex, column, columnIndex }) {
            if (
                row.isRedMark &&
                (column.property === 'oppositeSubjectID' ||
                    column.property === 'oppositeSubjectName')
            ) {
                return {
                    color: 'red'
                }
            }
            if (
                column.property == 'isRedMark' ||
                column.property == 'isCredit'
            ) {
                return {
                    'text-align': 'center'
                }
            }
        },
        cellMouseenterEvent({ row, column, cell }) {
            if (column.property == 'isRedMark') {
                this.$refs.xTip.toVisible(
                    cell,
                    this.gettipisRedMark(row.isRedMark)
                )
            } else if (column.property == 'isCredit') {
                this.$refs.xTip.toVisible(
                    cell,
                    this.gettipisCredit(row.isCredit)
                )
            }
        },
        cellMouseleaveEvent({ row, column, cell }) {
            this.$refs.xTip.close()
        },
        cellStyle() {
            //单元格边线颜色
            return 'border-right: 1px solid #cad7e9;border-bottom: 1px solid #cad7e9;'
        },
        //必选项加红星
        cell({ row, column, rowIndex, columnIndex }) {
            if (
                column.label == this.subjectTypeCode ||
                column.label == this.subjectTypeName ||
                column.label == '金额类型' ||
                column.label == '收发类别编码'
            ) {
                return 'mycell'
            }
        },
        Refresh() {
            const _this = this
            _this.initData(
                _this.subjectTypeId,
                _this.subjectType,
                _this.accountConfInfoValue,
                _this.brandValue,
                _this.moduleMark,
                _this.storeValue,
                _this.isMultiOrg,
                _this.storeListBySameBrandId
            )
        },
        initData(
            id,
            name,
            accountConfInfoValue,
            brandValue,
            moduleMark,
            storeValue,
            isMultiOrg,
            storeListBySameBrandId
        ) {
            this.allCoverageVisiable = false
            this.detailParamItems = []
            this.subjectTypeId = id
            this.subjectType = name
            this.subjectTypeCode = name + '编码'
            this.subjectTypeName = name + '名称'
            this.accountConfInfoValue = accountConfInfoValue
            this.brandValue = brandValue
            this.moduleMark = moduleMark
            this.storeValue = storeValue
            this.isMultiOrg = isMultiOrg
            this.storeListBySameBrandId = storeListBySameBrandId
            this.tableVisible = false
            this.loadData()
            this.loading = true
        },

        loadData() {
            const _this = this
            _this.tableData = []
            _this.formulaData = []
            SubjectService.getDetails({
                subjectTypeIdFilter: _this.subjectTypeId,
                brandIdFilter: _this.brandValue,
                accountConfInfoIdFilter: _this.accountConfInfoValue,
                storeIdFilter: _this.storeValue
            }).then((r) => {
                if (r.length > 0) {
                    _this.formulaData = r[0]
                    // _this.tableData = r[1];
                    _this.detailParamItems = r[4]
                    _this.showFields = r[5]
                    if (
                        _this.showFields == [] ||
                        _this.showFields.length == 0
                    ) {
                        _this.detailParamItems.forEach((item) => {
                            _this.showFields.push(item.fieldName)
                        })
                    }
                    if (r[1] != null && r[1].length > 0) {
                        r[1].forEach((item) => {
                            if (item.index >= this.maxindex) {
                                this.maxindex = item.index + 1
                            }
                            if (
                                item.detailParamsItems != null &&
                                item.detailParamsItems.length > 0
                            ) {
                                item.detailParamsItems.forEach((d) => {
                                    item[d.field] = d.id
                                    item[d.field + '名称'] = d.name
                                    item[d.field + '编码'] = d.code
                                })
                            }
                            let otherOrganType = ''
                            let entity = this.OrgTypes.find(
                                (a) => a.value === item.otherOrganType
                            )
                            if (entity != undefined) {
                                otherOrganType =
                                    entity.value + '~' + entity.label
                            }
                            item.otherOrganType = otherOrganType
                        })
                        _this.tableData = r[1]
                    }
                    _this.tableVisible = true
                    _this.setData()
                } else {
                    _this.loading = false
                }
                // _this.loading = false;
            })
            _this.$refs.detail.clearSelection()
        },
        checkSubjectComplate() {
            const _this = this
            _this.loading = true
            let checkComplateModel = {}
            checkComplateModel.accountId = _this.accountConfInfoValue
            checkComplateModel.brandId = _this.brandValue
            checkComplateModel.storeId = _this.storeValue
            checkComplateModel.subjectTypeId = _this.subjectTypeId
            SubjectService.checkSubjectGo(checkComplateModel)
                .then((r) => {
                    if (r.result.data.length == 0) {
                        _this.$notify({
                            title: '成功',
                            message: '无变动科目',
                            type: 'success',
                            position: 'bottom-right'
                        })
                    } else {
                        _this.$refs.SubjectCheckStr.openSelect(
                            checkComplateModel,
                            _this.subjectType,
                            r.result.data
                        )
                    }
                    _this.loading = false
                })
                .catch((e) => {
                    _this.loading = false
                })
        },
        //初始化数据
        setData() {
            const _this = this
            if (_this.formulaData != null && _this.formulaData.length > 0) {
                _this.formulaData.forEach((f) => {
                    if (f.detailParams != null && f.detailParams.length > 0) {
                        var detailParams = JSON.parse(f.detailParams)
                        detailParams.forEach((detailParam) => {
                            f[detailParam.fieldName] = detailParam.fieldName
                            f[detailParam.fieldName + '字段'] = detailParam.type
                            f[detailParam.fieldName + '操作'] = detailParam.oper
                            f[detailParam.fieldName + '值'] = detailParam.value
                        })
                    }
                })
                _this.formulaData = JSON.parse(
                    JSON.stringify(_this.formulaData)
                )
            }
            _this.infoheight = _this.maxheight - 304
            _this.loading = false
        },

        //筛选 过滤器
        dataFilter(value, row, column) {
            var property = column['property']
            if (property == 'oppositeSubjectID') {
                property = 'oppositeSubjectName'
            }
            return row[property] === value
        },

        //清除所有过滤器
        clearFilter() {
            var columns = this.$refs.detail.collectColumn
            columns.forEach((item) => {
                if (item.filters != null && item.filters.length > 0) {
                    if (
                        item.property == 'amountsource' ||
                        item.property == 'cloudSupplyAmount'
                    ) {
                        item.filters[0].checked = false
                    } else {
                        item.filters[0].checked = false
                        item.filters[0].data.sVal = ''
                        item.filters[0].data.vals = []
                    }
                }
            })
            this.$refs.detail.clearFilter()
        },

        //打开手续费计算对话框
        openServiceCharge(index) {
            let chooseindex = this.FindKeyIndex(index)
            this.$refs.SubjectServiceCharge.open(
                index,
                this.tableData[chooseindex].serviceCharge,
                this.tableData[chooseindex].oppositeSubjectName == undefined
                    ? ''
                    : this.tableData[chooseindex].oppositeSubjectName
            )
        },

        //手续费回传
        backServiceCharge(index, serviceCharge) {
            let chooseindex = this.FindKeyIndex(index)
            this.tableData[chooseindex].serviceCharge = serviceCharge
            // if (serviceCharge.indexOf("fieldName") == -1) {
            // } else {
            if (serviceCharge != null && serviceCharge.length > 0) {
                var serviceChargeStr = ''
                var serviceChargeJSON = JSON.parse(serviceCharge)
                serviceChargeJSON.forEach((item) => {
                    var times = item.时间
                    if (
                        times != null &&
                        times.length > 2 &&
                        times.indexOf('-')
                    ) {
                        var timebe = times.split('-')
                        if (timebe != null && timebe.length > 1) {
                            times = timebe[0] + '号-' + timebe[1] + '号'
                        }
                    }
                    serviceChargeStr =
                        serviceChargeStr +
                        '时间:' +
                        times +
                        ',公式:' +
                        item.公式 +
                        ',有效期:' +
                        item.有效期 +
                        ';'
                })
                this.tableData[chooseindex].serviceChargeStr = serviceChargeStr
                // }
            }

            this.tableData = JSON.parse(JSON.stringify(this.tableData))
        },
        //打开选择框
        openMutilSelect(index, type, isformula, value) {
            if (type == '品项大类' || type == '品项小类') {
                let chooseIndex = this.FindKeyIndex(index)
                var isCanMutil = false
                if (this.tableData[chooseIndex + 1] == undefined) {
                    isCanMutil = true
                }
                if (!isCanMutil) {
                    for (var i = chooseIndex; i < this.tableData.length; i++) {
                        if (type == '品项大类') {
                            if (this.tableData[i].品项大类 == undefined) {
                                isCanMutil = true
                            } else {
                                isCanMutil = false
                            }
                        }
                        if (type == '品项小类') {
                            if (this.tableData[i].品项小类 == undefined) {
                                isCanMutil = true
                            } else {
                                isCanMutil = false
                            }
                        }
                        if (!isCanMutil) {
                            break
                        }
                    }
                }

                if (isCanMutil) {
                    this.$refs.SubjectMutilSelect.openMutilSelect(
                        index,
                        type,
                        this.accountConfInfoValue,
                        this.brandValue,
                        this.moduleMark,
                        this.storeValue,
                        this.isMultiOrg,
                        isformula,
                        value
                    )
                } else {
                    this.$refs.SubjectSelect.openSelect(
                        index,
                        type,
                        this.accountConfInfoValue,
                        this.brandValue,
                        this.moduleMark,
                        this.storeValue,
                        this.isMultiOrg,
                        isformula
                    )
                }
            } else {
                this.$refs.SubjectMutilSelect.openMutilSelect(
                    index,
                    type,
                    this.accountConfInfoValue,
                    this.brandValue,
                    this.moduleMark,
                    this.storeValue,
                    this.isMultiOrg,
                    isformula,
                    value
                )
            }
        },
        selectMutilValue(index, type, item) {
            if (type == '品项大类' || type == '品项小类') {
                let chooseindex = this.FindKeyIndex(index)
                this.tableData[chooseindex][type] = ''
                this.tableData[chooseindex][type + '名称'] = ''
                if (item != null) {
                    for (var i = 0; i < item.length; i++) {
                        if (item[i] != undefined) {
                            if (i == 0) {
                                this.tableData[chooseindex + i][type + '名称'] =
                                    item[i].name
                                this.tableData[chooseindex + i][type] =
                                    item[i].code
                            } else {
                                this.maxindex++
                                this.tableData.push({
                                    index: this.maxindex,
                                    isRedMark: false
                                })
                                this.tableData[chooseindex + i][type + '名称'] =
                                    item[i].name
                                this.tableData[chooseindex + i][type] =
                                    item[i].code
                            }
                        }
                    }
                }
                this.tableData = JSON.parse(JSON.stringify(this.tableData))
            } else {
                let chooseindex = this.FindKeyIndex(index)
                this.tableData[chooseindex][type] = ''
                this.tableData[chooseindex][type + '名称'] = ''
                if (item != null) {
                    let codes = []
                    let names = []
                    item.forEach((s) => {
                        if (s != undefined) {
                            if (codes.indexOf(s.code) == -1) {
                                codes.push(s.code)
                                names.push(s.name)
                            }
                        }
                    })
                    this.tableData[chooseindex][type + '名称'] = names.join(';')
                    this.tableData[chooseindex][type] = codes.join(';')
                }
                this.tableData = JSON.parse(JSON.stringify(this.tableData))
            }
        },
        //打开选择框
        openSelect(index, type, isformula) {
            this.$refs.SubjectSelect.openSelect(
                index,
                type,
                this.accountConfInfoValue,
                this.brandValue,
                this.moduleMark,
                this.storeValue,
                this.isMultiOrg,
                isformula
            )
        },

        syncAddItemType(inComeItemTypeList, currentIndex) {
            const _this = this
            let chooseindex = this.FindKeyIndex(currentIndex)
            if (_this.tableData[chooseindex] != undefined) {
                _this.tableData.splice(chooseindex, 1)
            }
            for (var i = 0; i < inComeItemTypeList.length; i++) {
                let item = inComeItemTypeList[i]
                if (_this.tableData[chooseindex + i]) {
                    _this.tableData[chooseindex + i]['门店收入类型'] = item.id
                    _this.tableData[chooseindex + i]['门店收入类型编码'] =
                        item.code
                    _this.tableData[chooseindex + i]['门店收入类型名称'] =
                        item.name
                } else {
                    _this.maxindex++
                    _this.tableData.push({
                        index: this.maxindex,
                        isRedMark: false
                    })
                    _this.tableData[chooseindex + i]['门店收入类型'] = item.id
                    _this.tableData[chooseindex + i]['门店收入类型编码'] =
                        item.code
                    _this.tableData[chooseindex + i]['门店收入类型名称'] =
                        item.name
                }
            }
            this.tableData = JSON.parse(JSON.stringify(this.tableData))

            _this.$refs.detail.clearScroll().then(() => {
                _this.scrollDown()
            })
        },
        //选择数据回传
        selectValue(index, type, item) {
            let chooseindex = this.FindKeyIndex(index)
            if (item == null) {
                if (type == '会计科目') {
                    this.tableData[chooseindex].oppositeSubjectID = ''
                    this.tableData[chooseindex].oppositeSubjectName = ''
                    this.tableData[chooseindex].auxiliaryAccount = ''
                } else {
                    if (this.moduleMark == 'POS') {
                        this.tableData[chooseindex][type] = ''
                        this.tableData[chooseindex][type + '编码'] = ''
                        this.tableData[chooseindex][type + '名称'] = ''
                        if (type == '门店收银方式') {
                            //如果门店收银方式列有值，则金额来源的数据必须在AmountList
                            //                无值，则                    AmountListForEmpty
                            if (this.tableData[chooseindex].amountSource) {
                                let amountSource = this.AmountListForEmpty.find(
                                    (x) =>
                                        x ==
                                        this.tableData[chooseindex].amountSource
                                )
                                if (amountSource == null) {
                                    this.tableData[chooseindex].amountSource =
                                        ''
                                }
                            }
                        }
                    } else {
                        this.tableData[chooseindex][type] = ''
                        this.tableData[chooseindex][type + '名称'] = ''
                    }
                }
            } else {
                if (type == '会计科目') {
                    this.tableData[chooseindex].oppositeSubjectID =
                        item.subjectCode
                    this.tableData[chooseindex].oppositeSubjectName =
                        item.subjectName
                    this.tableData[chooseindex].auxiliaryAccount =
                        item.auxiliaryAccount
                } else {
                    if (this.moduleMark == 'POS') {
                        this.tableData[chooseindex][type] = item.id
                        this.tableData[chooseindex][type + '编码'] = item.code
                        this.tableData[chooseindex][type + '名称'] = item.name
                        if (type == '门店收银方式') {
                            //如果门店收银方式列有值，则金额来源的数据必须在AmountList
                            //                无值，则                    AmountListForEmpty
                            if (this.tableData[chooseindex].amountSource) {
                                let amountSource = this.AmountList.find(
                                    (x) =>
                                        x ==
                                        this.tableData[chooseindex].amountSource
                                )
                                if (amountSource == null) {
                                    this.tableData[chooseindex].amountSource =
                                        ''
                                }
                            }
                        }
                    } else {
                        this.tableData[chooseindex][type] = item.code
                        this.tableData[chooseindex][type + '名称'] = item.name
                    }
                }
            }
            this.tableData = JSON.parse(JSON.stringify(this.tableData))
        },

        //公式选择数据回传   todo
        selectValueFormula(index, type, item) {
            //let chooseindex = this.FindTableDataIndex(index);
            if (item == null) {
                if (type == '会计科目') {
                    this.formulaData[index].oppositeSubjectID = ''
                    this.formulaData[index].oppositeSubjectName = ''
                    this.formulaData[index].auxiliaryAccount = ''
                }
            } else {
                if (type == '会计科目') {
                    this.formulaData[index].oppositeSubjectID = item.subjectCode
                    this.formulaData[index].oppositeSubjectName =
                        item.subjectName
                    this.formulaData[index].auxiliaryAccount =
                        item.auxiliaryAccount
                }
            }
            this.formulaData = JSON.parse(JSON.stringify(this.formulaData))
        },

        //保存
        async save() {
            const _this = this
            _this.loading = true
            //敲黑板
            let num = 1
            let formulanum = 1
            let b = true
            if (_this.subjectTypeId == 0) {
                _this.$message({
                    message: '请选择科目类别'
                })
                _this.loading = false
                return
            }
            if (
                (_this.tableData == null || _this.tableData.length == 0) &&
                (_this.formulaData == null || _this.formulaData.length == 0)
            ) {
                this.$notify({
                    title: '提示',
                    message: '无待保存数据',
                    position: 'bottom-right'
                })
                b = false
                _this.loading = false
                return
            }

            _this.formulaData.forEach((item) => {
                let detailParams = []
                _this.detailParamItems.forEach((detailParamItemBase) => {
                    if (item[detailParamItemBase.fieldName + '字段']) {
                        detailParams.push({
                            fieldName: detailParamItemBase.fieldName,
                            type: item[detailParamItemBase.fieldName + '字段'],
                            oper: item[detailParamItemBase.fieldName + '操作'],
                            value: item[detailParamItemBase.fieldName + '值']
                        })
                    }
                })
                if (item.feeTax == '') {
                    item.feeTax = 0
                }
                item.index = formulanum
                item.detailParams = JSON.stringify(detailParams)
                formulanum = formulanum + 1
                if (b) {
                    //会计科目编码和金额类型是必填项
                    var isemptyoppositeSubjectID =
                        item.oppositeSubjectID == undefined ||
                        item.oppositeSubjectID == null ||
                        item.oppositeSubjectID == ''
                    var isemptycloudSupplyAmount =
                        (_this.moduleMark == 'SCM' ||
                            _this.moduleMark == 'SaiHu' ||
                            _this.moduleMark == 'SCM8' ||
                            _this.moduleMark == 'Z5' ||
                            _this.moduleMark == 'CRM') &&
                        (item.cloudSupplyAmount == undefined ||
                            item.cloudSupplyAmount == null ||
                            item.cloudSupplyAmount == '')
                    if (isemptyoppositeSubjectID || isemptycloudSupplyAmount) {
                        _this.deleteEmptyFormulaData()
                        b = false
                    }
                }
            })

            _this.tableData.forEach((item) => {
                let detailParams = []

                _this.detailParamItems.forEach((detailParamItemBase) => {
                    if (item[detailParamItemBase.fieldName]) {
                        detailParams.push({
                            fieldName: detailParamItemBase.fieldName,
                            value: item[detailParamItemBase.fieldName]
                        })
                        if (_this.moduleMark == 'POS') {
                            detailParams.push({
                                fieldName:
                                    detailParamItemBase.fieldName + '编码',
                                value: item[
                                    detailParamItemBase.fieldName + '编码'
                                ]
                            })
                        }
                        detailParams.push({
                            fieldName: detailParamItemBase.fieldName + '名称',
                            value: item[detailParamItemBase.fieldName + '名称']
                        })
                    }
                })
                item.index = num
                item.detailParams = JSON.stringify(detailParams)
                num = num + 1
                if (b) {
                    var isemptyoppositeSubjectID =
                        item.oppositeSubjectID == undefined ||
                        item.oppositeSubjectID == null ||
                        item.oppositeSubjectID == ''
                    var isemptycloudSupplyAmount =
                        (_this.moduleMark == 'SCM' ||
                            _this.moduleMark == 'SaiHu' ||
                            _this.moduleMark == 'SCM8' ||
                            _this.moduleMark == 'Z5' ||
                            _this.moduleMark == 'CRM') &&
                        (item.cloudSupplyAmount == undefined ||
                            item.cloudSupplyAmount == null ||
                            item.cloudSupplyAmount == '')
                    if (isemptyoppositeSubjectID || isemptycloudSupplyAmount) {
                        _this.deleteEmptyData()
                        b = false
                    }
                }
                let otherOrganType = ''
                if (
                    item.otherOrganType != '' &&
                    item.otherOrganType != undefined
                ) {
                    otherOrganType = item.otherOrganType.split('~')[0]
                    item.otherOrganType = otherOrganType
                } else {
                    item.otherOrganType = otherOrganType
                }
            })

            if (b) {
                let savedata = {}
                savedata.accountConfInfoId = _this.accountConfInfoValue
                savedata.brandId = _this.brandValue
                savedata.storeId = _this.storeValue
                savedata.subjectTypeId = _this.subjectTypeId
                savedata.formulas = _this.formulaData
                savedata.infos = _this.tableData
                SubjectService.save(savedata)
                    .then((r) => {
                        if (r.success) {
                            _this.$notify({
                                title: '成功',
                                message: '保存成功',
                                type: 'success',
                                position: 'bottom-right'
                            })
                        }
                        _this.loading = false
                        _this.initData(
                            _this.subjectTypeId,
                            _this.subjectType,
                            _this.accountConfInfoValue,
                            _this.brandValue,
                            _this.moduleMark,
                            _this.storeValue,
                            _this.isMultiOrg,
                            _this.storeListBySameBrandId
                        )
                    })
                    .catch((e) => {
                        _this.loading = false
                    })
            } else {
                _this.loading = false
            }
        },

        //科目详情信息删除空白行
        deleteEmptyData() {
            const _this = this
            _this
                .$confirm(
                    '科目详情信息有必填项未填写，是否删除未填写项?',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                )
                .then(() => {
                    let temp = []
                    _this.tableData.forEach((item) => {
                        let isDel = false
                        if (!isDel) {
                            var isemptyoppositeSubjectID =
                                item.oppositeSubjectID == undefined ||
                                item.oppositeSubjectID == null ||
                                item.oppositeSubjectID == ''
                            var isemptycloudSupplyAmount =
                                (_this.moduleMark == 'SCM' ||
                                    _this.moduleMark == 'SCM8' ||
                                    _this.moduleMark == 'Z5' ||
                                    _this.moduleMark == 'CRM') &&
                                (item.cloudSupplyAmount == undefined ||
                                    item.cloudSupplyAmount == null ||
                                    item.cloudSupplyAmount == '')
                            if (
                                isemptyoppositeSubjectID ||
                                isemptycloudSupplyAmount
                            ) {
                                isDel = true
                            }
                        }
                        if (!isDel) {
                            temp.push(item)
                        }
                    })
                    // _this.tableData = temp;
                    _this.tableData = JSON.parse(JSON.stringify(temp))

                    _this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                })
                .catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },

        //科目公式信息删除空白行
        deleteEmptyFormulaData() {
            const _this = this
            _this
                .$confirm(
                    '科目公式信息有必填项未填写，是否删除未填写项?',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                )
                .then(() => {
                    let temp = []
                    _this.formulaData.forEach((item) => {
                        let isDel = false
                        if (!isDel) {
                            var isemptyoppositeSubjectID =
                                item.oppositeSubjectID == undefined ||
                                item.oppositeSubjectID == null ||
                                item.oppositeSubjectID == ''
                            var isemptycloudSupplyAmount =
                                (_this.moduleMark == 'SCM' ||
                                    _this.moduleMark == 'SCM8' ||
                                    _this.moduleMark == 'Z5' ||
                                    _this.moduleMark == 'CRM') &&
                                (item.cloudSupplyAmount == undefined ||
                                    item.cloudSupplyAmount == null ||
                                    item.cloudSupplyAmount == '')
                            if (
                                isemptyoppositeSubjectID ||
                                isemptycloudSupplyAmount
                            ) {
                                isDel = true
                            }
                        }
                        if (!isDel) {
                            temp.push(item)
                        }
                    })
                    // _this.tableData = temp;
                    _this.formulaData = JSON.parse(JSON.stringify(temp))

                    _this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                })
                .catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },

        //增加科目详情
        addRow() {
            if (this.subjectTypeId == 0) {
                this.$message({
                    message: '请选择科目类别'
                })
            } else {
                this.maxindex++
                this.tableData.push({ index: this.maxindex, isRedMark: false })
            }
        },

        //新增科目公式
        setFormula() {
            if (this.subjectTypeId == 0) {
                this.$message({
                    message: '请选择科目类别'
                })
            } else {
                this.formulaData.push({})
            }
        },

        //快速复制
        quickCopy() {
            const _this = this
            var selections = _this.$refs.detail.selection
            if (_this.storeListBySameBrandId.length > 0) {
                var message = ''
                var ids = []
                selections.forEach((s) => {
                    if (s.id != undefined && s.id != null && s.id != 0) {
                        ids.push(s.id)
                    } else {
                        var rowindex =
                            _this.FindRowIndexByTableDataIndex(s.index) + 1
                        message += rowindex + ','
                    }
                })
                if (message != '') {
                    message = message.substring(0, message.length - 1)
                    _this.$message({
                        message: '第' + message + '行未保存，请先保存'
                    })
                } else {
                    _this.$refs.SubjectQuickCopy.openSelect(
                        ids,
                        _this.storeListBySameBrandId,
                        _this.storeValue,
                        _this.subjectTypeId
                    )
                }
            } else {
                _this.$message({ message: '没有要复制的目标门店' })
            }
        },

        deleteInfo(index, id) {
            const _this = this
            if (id != undefined && id != null && id != '' && id != 0) {
                SubjectService.deleteInfo({ id: id }).then((r) => {
                    if (r.success) {
                        _this.deleteTip(index)
                    }
                })
            } else {
                _this.deleteTip(index)
            }
        },

        deleteTip(index) {
            let chooseindex = this.FindKeyIndex(index)
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            this.tableData.splice(chooseindex, 1)
        },

        deleteFormulaRow(index, id) {
            const _this = this
            _this
                .$confirm('确定删除该科目设置吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    _this.deleteInfo(index, id)
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },

        //批量删除
        batchdelete() {
            var selections = this.$refs.detail.selection
            if (selections.length > 0) {
                const _this = this
                _this
                    .$confirm('确定删除这些科目设置吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        var ids = []
                        var indexs = []
                        selections.forEach((s) => {
                            if (
                                s.id != undefined &&
                                s.id != null &&
                                s.id != 0
                            ) {
                                ids.push(s.id)
                            }
                            var chooseindex = _this.FindKeyIndex(s.index)
                            indexs.push(chooseindex)
                        })
                        var b = true
                        if (ids.length > 0) {
                            SubjectService.batchDeleteInfo({ ids: ids }).then(
                                (r) => {
                                    if (r.success) {
                                        b = true
                                    } else {
                                        b = false
                                    }
                                }
                            )
                        }
                        if (b) {
                            indexs.sort(function (a, b) {
                                return b - a
                            })
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            indexs.forEach((i) => {
                                this.tableData.splice(i, 1)
                            })
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            } else {
                this.$message({
                    message: '请选择要删除的项'
                })
            }
        },

        //公式删除行
        deleteFormulaRow(index, id) {
            const _this = this
            _this
                .$confirm('确定删除该科目公式设置吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                .then(() => {
                    _this.deleteFormulaInfo(index, id)
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        deleteFormulaInfo(index, id) {
            const _this = this
            if (id != undefined && id != null && id != '' && id != 0) {
                SubjectService.deleteInfo({ id: id }).then((r) => {
                    if (r.success) {
                        _this.deleteFormulaTip(index)
                    }
                })
            } else {
                _this.deleteFormulaTip(index)
            }
        },

        deleteFormulaTip(index) {
            this.$message({
                type: 'success',
                message: '删除成功!'
            })
            this.formulaData.splice(index, 1)
        },

        //公式批量删除
        batchdFormulaelete() {
            var selections = this.$refs.formula.selection
            if (selections.length > 0) {
                const _this = this
                _this
                    .$confirm('确定删除这些科目公式设置吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        var ids = []
                        var indexs = []
                        selections.forEach((s) => {
                            if (
                                s.id != undefined &&
                                s.id != null &&
                                s.id != 0
                            ) {
                                ids.push(s.id)
                            }
                            indexs.push(s.index)
                        })
                        var b = true
                        if (ids.length > 0) {
                            SubjectService.batchDeleteInfo({ ids: ids }).then(
                                (r) => {
                                    if (r.success) {
                                        b = true
                                    } else {
                                        b = false
                                    }
                                }
                            )
                        }
                        if (b) {
                            indexs.sort(function (a, b) {
                                return b - a
                            })
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                            indexs.forEach((i) => {
                                this.formulaData.splice(i, 1)
                            })
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            } else {
                this.$message({
                    message: '请选择要删除的项'
                })
            }
        },

        //多选复制
        batcopy() {
            var selections = this.$refs.detail.selection
            if (selections.length > 0) {
                const _this = this
                selections.forEach((s) => {
                    var newObj = JSON.parse(JSON.stringify(s))
                    newObj.id = null
                    this.maxindex++
                    newObj.index = this.maxindex
                    newObj._XID = null
                    this.tableData.push(newObj)
                })
            } else {
                this.$message({
                    message: '请选择要复制的项'
                })
            }
        },

        // 同上
        copyLast(index, item) {
            if (index == 0) {
                return
            } else {
                let chooseindex = this.FindKeyIndex(index)
                let targetindex = this.FindRowIndexByTableDataIndex(index) - 1
                if (item == 'oppositeSubject') {
                    this.tableData[chooseindex].oppositeSubjectID =
                        this.$refs.detail.tableData[
                            targetindex
                        ].oppositeSubjectID
                    this.tableData[chooseindex].oppositeSubjectName =
                        this.$refs.detail.tableData[
                            targetindex
                        ].oppositeSubjectName
                    this.tableData[chooseindex].auxiliaryAccount =
                        this.$refs.detail.tableData[
                            targetindex
                        ].auxiliaryAccount
                } else if (item == 'cloudSupplyAmount') {
                    this.tableData[chooseindex][item] =
                        this.$refs.detail.tableData[targetindex][item]
                } else if (item == 'feeTax') {
                    this.tableData[chooseindex][item] =
                        this.$refs.detail.tableData[targetindex][item]
                } else {
                    this.tableData[chooseindex][item] =
                        this.$refs.detail.tableData[targetindex][item]
                    this.tableData[chooseindex][item + '编码'] =
                        this.$refs.detail.tableData[targetindex][item + '编码']
                    this.tableData[chooseindex][item + '名称'] =
                        this.$refs.detail.tableData[targetindex][item + '名称']
                    if (item == '门店收银方式') {
                        //如果门店收银方式列有值，则金额来源的数据必须在AmountList
                        //                无值，则                    AmountListForEmpty
                        if (this.tableData[chooseindex].amountSource) {
                            let item = this.AmountList.find(
                                (item) =>
                                    item ==
                                    this.tableData[chooseindex].amountSource
                            )
                            if (item == null) {
                                this.tableData[chooseindex].amountSource = ''
                            }
                        }
                    }
                }
                this.tableData = JSON.parse(JSON.stringify(this.tableData))
            }
        },
        //是否可以同上复制
        cancopylast(index, item) {
            let rowindex = this.FindRowIndexByTableDataIndex(index)
            if (rowindex == 0) {
                return false
            } else {
                var target = this.$refs.detail.tableData[rowindex - 1][item]
                //判断上一行本列是否有值
                if (target != null && target !== '' && target != undefined) {
                    return true
                } else {
                    return false
                }
            }
        },

        //是否可以向下复制
        cancopyTo(index, item) {
            let rowindex = this.FindRowIndexByTableDataIndex(index)
            if (rowindex == this.tableData.length - 1) {
                return false
            } else {
                //判断本行本列是否有值
                var target = this.$refs.detail.tableData[rowindex][item]
                if (target != null && target !== '' && target != undefined) {
                    return true
                } else {
                    return false
                }
            }
        },

        //向下复制
        copyTo(index, item) {
            var mlength = this.tableData.length

            let chooseindex = this.FindKeyIndex(index)
            let rowindex = this.FindRowIndexByTableDataIndex(index)
            if (item == 'oppositeSubject') {
                for (var i = rowindex + 1; i < mlength; i++) {
                    let targetindex = this.FindTableDataKeyIndexByRowIndex(i)
                    this.tableData[targetindex].oppositeSubjectID =
                        this.tableData[chooseindex].oppositeSubjectID
                    this.tableData[targetindex].oppositeSubjectName =
                        this.tableData[chooseindex].oppositeSubjectName
                    this.tableData[targetindex].auxiliaryAccount =
                        this.tableData[chooseindex].auxiliaryAccount
                }
            } else if (item == 'cloudSupplyAmount') {
                for (var i = rowindex + 1; i < mlength; i++) {
                    let targetindex = this.FindTableDataKeyIndexByRowIndex(i)
                    this.tableData[targetindex].cloudSupplyAmount =
                        this.tableData[chooseindex].cloudSupplyAmount
                }
            } else if (item == 'feeTax') {
                for (var i = rowindex + 1; i < mlength; i++) {
                    let targetindex = this.FindTableDataKeyIndexByRowIndex(i)
                    this.tableData[targetindex].feeTax =
                        this.tableData[chooseindex].feeTax
                }
            } else {
                for (var i = rowindex + 1; i < mlength; i++) {
                    let targetindex = this.FindTableDataKeyIndexByRowIndex(i)
                    this.tableData[targetindex][item] =
                        this.tableData[chooseindex][item]
                    this.tableData[targetindex][item + '编码'] =
                        this.tableData[chooseindex][item + '编码']
                    this.tableData[targetindex][item + '名称'] =
                        this.tableData[chooseindex][item + '名称']

                    if (item == '门店收银方式') {
                        //如果门店收银方式列有值，则金额来源的数据必须在AmountList
                        //                无值，则                    AmountListForEmpty
                        if (this.tableData[targetindex].amountSource) {
                            let item = this.AmountList.find(
                                (item) =>
                                    item ==
                                    this.tableData[targetindex].amountSource
                            )
                            if (item == null) {
                                this.tableData[targetindex].amountSource = ''
                            }
                        }
                    }
                }
            }
            this.tableData = JSON.parse(JSON.stringify(this.tableData))
        },
        clearDetail() {
            this.tableData = []
            this.detailParamItems = []
        },

        // 通过 tabledata 的index字段值 ,获得在tableData数据中的索引值
        FindKeyIndex(index) {
            let keyindex = 0
            let b = true
            this.tableData.forEach((d) => {
                if (b) {
                    if (d.index == index) {
                        b = false
                    } else {
                        keyindex++
                    }
                }
            })
            return keyindex
        },
        // 通过 tabledata 的index字的值 ,获得在表格中的行号
        FindRowIndexByTableDataIndex(index) {
            let rowindex = 0
            let b = true
            this.$refs.detail.tableData.forEach((d) => {
                if (b) {
                    if (d.index == index) {
                        b = false
                    } else {
                        rowindex++
                    }
                }
            })
            return rowindex
        },
        //通过行号获得tableData中的索引值
        FindTableDataKeyIndexByRowIndex(rowindex) {
            //通过行号获得index字段的值
            var index = this.$refs.detail.tableData[rowindex].index
            //通过index字段值获得在tableData中的索引值
            var keyindex = this.FindKeyIndex(index)
            return keyindex
        },

        //红字 蓝字 提示
        gettipisRedMark(b) {
            return b ? '红字' : '蓝字'
        },
        //红字 蓝字 会计科目样式
        getredMarkclass(b) {
            return b ? 'redMark' : ''
        },
        redmarkChange(id, isRedMark) {
            if (id != undefined && id > 0) {
                const _this = this
                var ids = []
                ids.push(id)
                if (isRedMark) {
                    SubjectService.batchSetRedMark({ ids: ids }).then((r) => {
                        if (!r.success) {
                            _this.$message({
                                type: 'info',
                                message: r.erroe
                            })
                        }
                    })
                } else {
                    SubjectService.batchSetBlueMark({ ids: ids }).then((r) => {
                        if (!r.success) {
                            _this.$message({
                                type: 'info',
                                message: r.erroe
                            })
                        }
                    })
                }
            }
        },
        //批量设置红蓝字
        batred(isred) {
            var selections = this.$refs.detail.selection
            if (selections.length > 0) {
                const _this = this
                _this
                    .$confirm(
                        '确定将这些科目设置为' +
                            (isred ? '红字' : '蓝字') +
                            '吗?',
                        '提示',
                        {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        var ids = []
                        var indexs = []
                        selections.forEach((s) => {
                            if (
                                s.id != undefined &&
                                s.id != null &&
                                s.id != 0
                            ) {
                                ids.push(s.id)
                            }
                            var chooseindex = _this.FindKeyIndex(s.index)
                            indexs.push(chooseindex)
                        })
                        var b = true
                        if (ids.length > 0) {
                            if (isred) {
                                SubjectService.batchSetRedMark({
                                    ids: ids
                                }).then((r) => {
                                    if (r.success) {
                                        b = true
                                    } else {
                                        b = false
                                    }
                                })
                            } else {
                                SubjectService.batchSetBlueMark({
                                    ids: ids
                                }).then((r) => {
                                    if (r.success) {
                                        b = true
                                    } else {
                                        b = false
                                    }
                                })
                            }
                        }
                        if (b) {
                            indexs.sort(function (a, b) {
                                return b - a
                            })
                            indexs.forEach((i) => {
                                if (isred) {
                                    _this.tableData[i].isRedMark = true
                                } else {
                                    _this.tableData[i].isRedMark = false
                                }
                            })
                            _this.$message({
                                type: 'success',
                                message: '操作成功!'
                            })
                            _this.$refs.detail.clearSelection()
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消操作'
                        })
                    })
            } else {
                this.$message({
                    message: '请选择要操作的项'
                })
            }
        },
        gettipisCredit(b) {
            return b ? '贷方' : '借方'
        },
        isCreditChange(id, isCredit) {
            if (id != undefined && id > 0) {
                const _this = this
                var ids = []
                ids.push(id)
                SubjectService.batchSetCredit({ ids: ids, b: isCredit }).then(
                    (r) => {
                        if (!r.success) {
                            _this.$message({
                                type: 'info',
                                message: r.erroe
                            })
                        }
                    }
                )
            }
        },
        batisCredit(isCredit) {
            var selections = this.$refs.detail.selection
            if (selections.length > 0) {
                const _this = this
                _this
                    .$confirm(
                        '确定将这些科目设置为' +
                            (isCredit ? '贷方' : '借方') +
                            '吗?',
                        '提示',
                        {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        var ids = []
                        var indexs = []
                        selections.forEach((s) => {
                            if (
                                s.id != undefined &&
                                s.id != null &&
                                s.id != 0
                            ) {
                                ids.push(s.id)
                            }
                            var chooseindex = _this.FindKeyIndex(s.index)
                            indexs.push(chooseindex)
                        })
                        var b = true
                        if (ids.length > 0) {
                            SubjectService.batchSetCredit({
                                ids: ids,
                                b: isCredit
                            }).then((r) => {
                                if (r.success) {
                                    b = true
                                } else {
                                    b = false
                                }
                            })
                        }
                        if (b) {
                            indexs.sort(function (a, b) {
                                return b - a
                            })
                            indexs.forEach((i) => {
                                if (isCredit) {
                                    _this.tableData[i].isCredit = true
                                } else {
                                    _this.tableData[i].isCredit = false
                                }
                            })
                            _this.$message({
                                type: 'success',
                                message: '操作成功!'
                            })
                            _this.$refs.detail.clearSelection()
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消操作'
                        })
                    })
            } else {
                this.$message({
                    message: '请选择要操作的项'
                })
            }
        },
        exportExcel(type) {
            const workbook = new Excel.Workbook()
            const worksheet = workbook.addWorksheet(this.subjectType)

            var columns = [
                {
                    header: this.subjectTypeCode,
                    key: 'oppositeSubjectID',
                    width: 20
                },
                {
                    header: this.subjectTypeName,
                    key: 'oppositeSubjectName',
                    width: 30
                },
                { header: '辅助核算', key: 'auxiliaryAccount', width: 20 }
            ]
            // if (this.moduleMark != "CRM") {
            columns.push({ header: '红蓝字', key: 'isRedMark', width: 20 })
            columns.push({ header: '借贷方', key: 'isCredit', width: 20 })
            if (
                this.moduleMark == 'SCM' ||
                this.moduleMark == 'SaiHu' ||
                this.moduleMark == 'SCM8' ||
                this.moduleMark == 'Z5' ||
                this.moduleMark == 'CRM'
            ) {
                columns.push({
                    header: '金额类型',
                    key: 'cloudSupplyAmount',
                    width: 20
                })
            } else {
                columns.push({
                    header: '金额来源',
                    key: 'amountSource',
                    width: 20
                })
            }
            if (this.moduleMark == 'SCM8') {
                columns.push({
                    header: '对方机构属性',
                    key: 'otherOrganType',
                    width: 20
                })
            }

            // }
            var isamountSource = false
            if (this.moduleMark == 'POS') {
                this.detailParamItems.forEach((d) => {
                    columns.push({
                        header: d.fieldName,
                        key: d.fieldName,
                        width: 20
                    })
                    columns.push({
                        header: d.fieldName + '编码',
                        key: d.fieldName + '编码',
                        width: 20
                    })
                    columns.push({
                        header: d.fieldName + '名称',
                        key: d.fieldName + '名称',
                        width: 20
                    })
                    this.isamountSource = true
                })
                columns.push({ header: '税率%', key: 'feeTax', width: 20 })
                columns.push({
                    header: '手续费',
                    key: 'serviceChargeStr',
                    width: 20
                })
            } else {
                this.detailParamItems.forEach((d) => {
                    columns.push({
                        header: d.fieldName + '编码',
                        key: d.fieldName,
                        width: 20
                    })
                    columns.push({
                        header: d.fieldName + '名称',
                        key: d.fieldName + '名称',
                        width: 20
                    })
                })
                if (
                    this.subjectType == '收入科目' ||
                    this.subjectType == '销项税科目'
                ) {
                    columns.push({ header: '税率%', key: 'feeTax', width: 20 })
                }
            }

            worksheet.columns = columns
            if (type != 'template') {
                this.tableData.forEach((item) => {
                    var row = {
                        oppositeSubjectID: item.oppositeSubjectID,
                        oppositeSubjectName: item.oppositeSubjectName,
                        auxiliaryAccount: item.auxiliaryAccount,
                        cloudSupplyAmount: item.cloudSupplyAmount,
                        feeTax: item.feeTax,
                        serviceChargeStr: item.serviceChargeStr,
                        amountSource: item.amountSource,
                        otherOrganType: item.otherOrganType
                    }

                    row.isRedMark = item.isRedMark ? '红字' : '蓝字'
                    row.isCredit = item.isCredit ? '贷方' : '借方'
                    if (this.moduleMark == 'POS') {
                        this.detailParamItems.forEach((d) => {
                            row[d.fieldName] = item[d.fieldName]
                            row[d.fieldName + '编码'] =
                                item[d.fieldName + '编码']
                            row[d.fieldName + '名称'] =
                                item[d.fieldName + '名称']
                        })
                    } else {
                        this.detailParamItems.forEach((d) => {
                            row[d.fieldName] = item[d.fieldName]
                            row[d.fieldName + '名称'] =
                                item[d.fieldName + '名称']
                        })
                    }
                    worksheet.addRow(row)
                })
            } else {
                for (let i = 0; i < 1; i++) {
                    var row = {
                        oppositeSubjectID: '',
                        oppositeSubjectName: '',
                        auxiliaryAccount: '',
                        cloudSupplyAmount: '',
                        feeTax: 0,
                        serviceChargeStr: '',
                        amountSource: ''
                    }
                    row.isRedMark = ''
                    row.isCredit = ''
                    if (this.moduleMark == 'POS') {
                        this.detailParamItems.forEach((d) => {
                            row[d.fieldName] = ''
                            row[d.fieldName + '编码'] = ''
                            row[d.fieldName + '名称'] = ''
                        })
                    } else {
                        this.detailParamItems.forEach((d) => {
                            row[d.fieldName] = ''
                            row[d.fieldName + '名称'] = ''
                        })
                    }
                    var isRedMarkCell = row.isRedMark
                    worksheet.addRow(row)
                }
            }

            // if (this.moduleMark != "CRM") {
            var isRedMarkCol = worksheet.getColumn('isRedMark')
            isRedMarkCol.eachCell(function (cell, rowNumber) {
                cell.dataValidation = {
                    type: 'list',
                    allowBlank: true,
                    formulae: ['"红字,蓝字"']
                }
            })

            var isCreditCol = worksheet.getColumn('isCredit')
            isCreditCol.eachCell(function (cell, rowNumber) {
                cell.dataValidation = {
                    type: 'list',
                    allowBlank: true,
                    formulae: ['"借方,贷方"']
                }
            })
            if (
                this.moduleMark == 'SCM' ||
                this.moduleMark == 'SaiHu' ||
                this.moduleMark == 'SCM8' ||
                this.moduleMark == 'Z5'
            ) {
                var cloudSupplyAmountCol =
                    worksheet.getColumn('cloudSupplyAmount')
                cloudSupplyAmountCol.eachCell(function (cell, rowNumber) {
                    cell.dataValidation = {
                        type: 'list',
                        allowBlank: true,
                        formulae: [
                            '"成本金额,含税金额,税额,非税配送金额,销售/调拨税额,含税配送金额"'
                        ]
                    }
                })
            }
            if (this.moduleMark == 'CRM') {
                var cloudSupplyAmountCol =
                    worksheet.getColumn('cloudSupplyAmount')
                cloudSupplyAmountCol.eachCell(function (cell, rowNumber) {
                    cell.dataValidation = {
                        type: 'list',
                        allowBlank: true,
                        formulae: ['"充值本金,充值赠送,工本费"']
                    }
                })
            }
            // }

            if (isamountSource) {
                var amountSourceCol = worksheet.getColumn('amountSource')
                amountSourceCol.eachCell(function (cell, rowNumber) {
                    cell.dataValidation = {
                        type: 'list',
                        allowBlank: true,
                        formulae: ['"收入金额,非收入金额,实收金额"']
                    }
                })
            }
            var xlsxname = this.subjectType + '模板.xlsx'
            if (type != 'template') {
                xlsxname = this.subjectType + '数据.xlsx'
            }
            workbook.xlsx.writeBuffer().then(function (buffer) {
                try {
                    FileSaver.saveAs(
                        new Blob([buffer], {
                            type: 'application/octet-stream'
                        }),
                        xlsxname
                    )
                } catch (e) {
                    if (typeof console !== 'undefined') console.log(e, buffer)
                }
                return buffer
            })
        },
        importExcel() {
            this.importExcelVisible = true
        },
        filechange() {
            this.fileVisible = true
            this.$nextTick(function () {
                this.$refs.uploadExcel.click()
            })
        },
        importfile(obj) {
            let _this = this
            _this.filechangeloading = true
            _this.importExcelloading = true
            // let inputDOM = this.$refs.inputer;
            // 通过DOM取文件数据
            this.file = event.currentTarget.files[0]
            var rABS = false //是否将文件读取为二进制字符串
            var f = this.file
            var reader = new FileReader()
            //if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function (f) {
                var binary = ''
                var rABS = false //是否将文件读取为二进制字符串
                var pt = this
                var wb //读取完成的数据
                var outdata
                var reader = new FileReader()
                reader.onload = function (e) {
                    var bytes = new Uint8Array(reader.result)
                    var length = bytes.byteLength
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i])
                    }
                    var XLSX = require('xlsx')
                    if (rABS) {
                        wb = XLSX.read(btoa(fixdata(binary)), {
                            //手动转化
                            type: 'base64'
                        })
                    } else {
                        wb = XLSX.read(binary, {
                            type: 'binary'
                        })
                    }
                    outdata = XLSX.utils.sheet_to_json(
                        wb.Sheets[wb.SheetNames[0]]
                    ) //outdata就是你想要的东西
                    let infoList = []
                    var b = true
                    outdata.forEach((item) => {
                        if (b) {
                            var rowdata = {}
                            rowdata.oppositeSubjectID =
                                item[_this.subjectTypeCode]
                            if (
                                rowdata.oppositeSubjectID == undefined ||
                                rowdata.oppositeSubjectID == null
                            ) {
                                _this.$message.warning('导入数据模板不正确')
                                b = false
                            }
                            if (b) {
                                rowdata.oppositeSubjectName =
                                    item[_this.subjectTypeName]
                                rowdata.auxiliaryAccount = item['辅助核算']
                                rowdata.isRedMark =
                                    item['红蓝字'] == '红字' ? true : false
                                rowdata.isCredit =
                                    item['借贷方'] == '贷方' ? true : false
                                rowdata.cloudSupplyAmount = item['金额类型']
                                rowdata.otherOrganType = item['对方机构属性']

                                let detailParams = []
                                _this.detailParamItems.forEach(
                                    (detailParamItemBase) => {
                                        if (
                                            item[
                                                detailParamItemBase.fieldName +
                                                    '名称'
                                            ]
                                        ) {
                                            if (_this.moduleMark == 'POS') {
                                                detailParams.push({
                                                    fieldName:
                                                        detailParamItemBase.fieldName,
                                                    value: item[
                                                        detailParamItemBase
                                                            .fieldName
                                                    ]
                                                })
                                                detailParams.push({
                                                    fieldName:
                                                        detailParamItemBase.fieldName +
                                                        '编码',
                                                    value: item[
                                                        detailParamItemBase.fieldName +
                                                            '编码'
                                                    ]
                                                })
                                            } else {
                                                detailParams.push({
                                                    fieldName:
                                                        detailParamItemBase.fieldName,
                                                    value: item[
                                                        detailParamItemBase.fieldName +
                                                            '编码'
                                                    ]
                                                })
                                            }
                                            detailParams.push({
                                                fieldName:
                                                    detailParamItemBase.fieldName +
                                                    '名称',
                                                value: item[
                                                    detailParamItemBase.fieldName +
                                                        '名称'
                                                ]
                                            })
                                        }
                                    }
                                )
                                rowdata.detailParams =
                                    JSON.stringify(detailParams)

                                if (_this.moduleMark == 'POS') {
                                    rowdata.serviceChargeStr = item['手续费']
                                }
                                rowdata.feeTax = item['税率%']
                                rowdata.amountSource = item['金额来源']

                                infoList.push(rowdata)
                            }
                        }
                    })
                    if (b) {
                        let savedata = {}
                        savedata.accountConfInfoId = _this.accountConfInfoValue
                        savedata.brandId = _this.brandValue
                        savedata.storeId = _this.storeValue
                        savedata.subjectTypeId = _this.subjectTypeId
                        savedata.formulas = _this.formulaData
                        savedata.infos = infoList
                        SubjectService.excelImport(savedata)
                            .then((r) => {
                                var result = r.result
                                _this.importExcelResult = result
                                if (
                                    result.errorEntites != null &&
                                    result.errorEntites != [] &&
                                    result.errorEntites.length > 0
                                ) {
                                    result.errorCount = result.errorCount
                                    result.successCount =
                                        result.totalCount - result.errorCount
                                    _this.importExcelResultVisible = true
                                } else {
                                    _this.$notify({
                                        title: '成功',
                                        message: '导入成功',
                                        type: 'success',
                                        position: 'bottom-right'
                                    })
                                }
                                _this.filechangeloading = false
                                _this.importExcelVisible = false
                                _this.importExcelloading = false
                                _this.importExcelResult.successEntites.forEach(
                                    (item) => {
                                        _this.maxindex++
                                        item.index = _this.maxindex
                                        if (
                                            item.detailParamsItems != null &&
                                            item.detailParamsItems.length > 0
                                        ) {
                                            item.detailParamsItems.forEach(
                                                (d) => {
                                                    item[d.field] = d.id
                                                    item[d.field + '名称'] =
                                                        d.name
                                                    item[d.field + '编码'] =
                                                        d.code
                                                }
                                            )
                                        }
                                        _this.tableData.push(item)
                                    }
                                )
                            })
                            .catch((e) => {
                                _this.filechangeloading = false
                                _this.importExcelVisible = false
                                _this.importExcelloading = false
                            })
                    } else {
                        _this.filechangeloading = false
                        _this.importExcelVisible = false
                        _this.importExcelloading = false
                    }
                    _this.fileVisible = false
                }
                reader.readAsArrayBuffer(f)
            }
            if (rABS) {
                reader.readAsArrayBuffer(f)
            } else {
                reader.readAsBinaryString(f)
            }
        },
        exportExcelforimportExcelError() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document
                        .querySelector('#importexcelerror')
                        .removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#importexcelerror').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#importexcelerror'),
                    xlsxParam
                )
            }
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    '导入数据校验失败信息.xlsx'
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }
            return wbout
        },
        showField() {
            const _this = this
            _this.showFieldVisible = true
        },
        showFieldChange() {
            const _this = this
            let savedata = {}
            savedata.accountConfInfoId = _this.accountConfInfoValue
            savedata.brandId = _this.brandValue
            savedata.storeId = _this.storeValue
            savedata.subjectTypeId = _this.subjectTypeId
            savedata.showFields = ''
            if (_this.showFields != [] || _this.showFields.length >= 0) {
                savedata.showFields = _this.showFields.join(',')
            }
            SubjectService.showFieldSave(savedata).then((r) => {})
        },
        isshowField(fieldName) {
            const _this = this
            var b = false
            if (_this.showFields == [] || _this.showFields.length == 0) {
                b = true
            } else {
                let item = _this.showFields.find((item) => item == fieldName)
                if (item) {
                    b = true
                }
            }
            return b
        },
        checkComplate() {
            this.checkComplateOver = false
            this.checkComplateVisible = true
            this.datePeriod = 7
        },
        checkInComeComplate() {
            this.checkInComeComplateOver = false
            this.checkInComeComplateVisible = true
            this.dateInComePeriod = 7
        },
        checkInComeComplateGo() {
            const _this = this
            this.checkInComeComplateLoading = true
            let checkIncomeComplateModel = {}
            checkIncomeComplateModel.accountId = _this.accountConfInfoValue
            checkIncomeComplateModel.brandId = _this.brandValue
            checkIncomeComplateModel.storeId = _this.storeValue
            checkIncomeComplateModel.subjectTypeId = _this.subjectTypeId
            checkIncomeComplateModel.datePeriod = _this.dateInComePeriod
            SubjectService.checkInComeComplateGo(checkIncomeComplateModel)
                .then((r) => {
                    if (r.success) {
                        _this.checkInComeComplateLoading = false
                        _this.unSetInComeDataEntitites =
                            r.result.unSetDataEntitites
                        _this.checkInComeComplateOver = true
                    }
                })
                .catch((e) => {
                    _this.checkInComeComplateLoading = false
                })
        },
        checkComplateGo() {
            const _this = this
            this.checkComplateLoading = true
            let checkComplateModel = {}
            checkComplateModel.accountId = _this.accountConfInfoValue
            checkComplateModel.brandId = _this.brandValue
            checkComplateModel.storeId = _this.storeValue
            checkComplateModel.subjectTypeId = _this.subjectTypeId
            checkComplateModel.startTime = _this.voucherQueryModel.startTime
            checkComplateModel.endTime = _this.voucherQueryModel.endTime
            checkComplateModel.datePeriod = _this.datePeriod
            checkComplateModel.amountType = _this.amountType
            SubjectService.checkComplateGo(checkComplateModel)
                .then((r) => {
                    if (r.success) {
                        _this.checkComplateLoading = false
                        _this.unSetDataEntitites = r.result.unSetDataEntitites
                        _this.checkComplateOver = true
                    }
                })
                .catch((e) => {
                    _this.checkComplateLoading = false
                })
        },
        syncUnSetEntity() {
            const _this = this
            _this.checkComplateOver = true
            _this.unSetDataEntitites.forEach((item) => {
                _this.maxindex++
                let detailParams = []
                let detailParamsItems = []
                let rowData = {}
                _this.detailParamItems.forEach((detailParamItemBase) => {
                    detailParams.push({
                        fieldName: detailParamItemBase.fieldName,
                        value: item.paywayId
                    })
                    detailParams.push({
                        fieldName: detailParamItemBase.fieldName + '编码',
                        value: item.paywayCode
                    })
                    detailParams.push({
                        fieldName: detailParamItemBase.fieldName + '名称',
                        value: item.paywayName
                    })
                    detailParamsItems.push({
                        code: item.paywayCode,
                        id: item.paywayId,
                        name: item.paywayName,
                        field: detailParamItemBase.fieldName
                    })
                })
                if (_this.amountType != '全部') {
                    rowData.amountSource = _this.amountType
                }
                rowData.detailParams = JSON.stringify(detailParams)
                rowData.index = _this.maxindex
                rowData.accountConfInfoId = _this.accountConfInfoValue
                rowData.subjectTypeId = _this.subjectTypeId
                rowData.detailParamsItems = detailParamsItems
                if (
                    rowData.detailParamsItems != null &&
                    rowData.detailParamsItems.length > 0
                ) {
                    rowData.detailParamsItems.forEach((d) => {
                        rowData[d.field] = d.id
                        rowData[d.field + '名称'] = d.name
                        rowData[d.field + '编码'] = d.code
                    })
                }
                rowData.feeTax = 0
                _this.tableData.push(rowData)
            })

            _this.checkComplateVisible = false
            _this.$refs.detail.clearScroll().then(() => {
                _this.scrollDown()
            })
        },
        scrollDown() {
            const el = this.$refs.detail.$el.querySelector(
                '.vxe-table--body-wrapper'
            )
            if (el) {
                el.scrollTop = 10000
                el.scrollDown = 10000
            }
        },
        exportExcelforcheckComplateunError() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document
                        .querySelector('#checkComplateunError')
                        .removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#checkComplateunError').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#checkComplateunError'),
                    xlsxParam
                )
            }
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    '结算方式检测未设置项.xlsx'
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }
            return wbout
        }
    }
}
</script>

<style scoped="scoped">
.text-flow {
    float: left;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.wl-select-group__wrap li span {
    color: #909399;
}
.wl-select-group__wrap + .el-select-dropdown__item {
    margin-top: 28px;
}

.toggletable .el-select,
.toggletable .el-input,
.toggletable .myshowup {
    display: none;
    margin-right: 5px;
}

.toggletable .current-row .myshowup + .el-select {
    display: inline-block;
    white-space: nowrap;
}
.toggletable .current-row .el-select {
    display: block;
}
.toggletable .current-row .el-input {
    display: block;
}
.toggletable .current-row .myshowup.el-button {
    display: inline-block;
    white-space: nowrap;
}
.toggletable .current-row .el-select + span {
    display: none;
}
.toggletable .current-row .el-input + span {
    display: none;
}
.myshowup.el-button {
    border-radius: 16px;
}
.toggleColumn .myshowup {
    display: none !important;
}
.current-row .toggleColumn .el-select {
    display: block !important;
    width: 100%;
    white-space: nowrap;
}
.current-row .toggleColumn .el-input {
    display: block !important;
    width: 100%;
    white-space: nowrap;
}
.current-row .toggleColumn span {
    display: none;
}
.toggleColumn .el-select {
    display: none !important;
    width: 100%;
}
.toggleColumn .el-input {
    display: none !important;
    width: 100%;
}
.toggleColumn span {
    display: block;
}
.floatleft {
    float: left;
}
.subtitle {
    font-size: 14px;
    line-height: 24px;
    color: #606266;
}
.paddingtop12 {
    padding-top: 12px;
}
.batchdelbutton {
    margin-top: 14px;
}
.redMark {
    color: red;
}
table .el-button + .el-button {
    margin-left: 0px;
}
table .el-button--mini,
.el-button--mini.is-round {
    padding: 1px 1px !important;
    color: #234e8d;
}
.el-checkbox {
    display: block;
}
.el-checkbox + .el-checkbox {
    margin-left: 0px !important;
}
.vxe-table /deep/ .vxe-header--column.headercell {
    background-color: #eaeef0 !important;
    color: #526c79;
    white-space: nowrap;
}
.vxe-table /deep/ .vxe-body--column.cellborder {
    border-right: 1px solid #cad7e9 !important;
    border-bottom: 1px solid #cad7e9 !important;
}
.cloudSupplySelect {
    -webkit-appearance: menulist;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 98px;
    float: left;
    height: 28px;
    line-height: 28px;
}
.cloudSupplySelect:before {
    content: '\e605';
}
.cloudSupplyOption {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
}
table .el-button--mini,
.el-button--mini.is-round {
    line-height: 28px;
}
.vxe-table /deep/ .vxe-body--column.col--valid-error /deep/ .vxe-cell--valid {
    display: none;
}
.margintop20 {
    margin-top: 20px;
}
.vxe-table /deep/ .vxe-body--column.col--valid-error /deep/ .vxe-cell--valid {
    display: none;
    background-color: transparent;
}
.vxe-table /deep/ .vxe-body--column.col--valid-error /deep/ .vxe-cell--valid {
    display: none;
    white-space: nowrap;
}
.vxe-table--render-default
    .vxe-body--column.col--valid-error
    .vxe-cell--valid
    .vxe-cell--valid-msg {
    display: inline-block;
    border-radius: 4px;
    padding: 8px 12px;
    color: #fff;
    /* background-color: #f56c6c; */
    pointer-events: auto;
}
.vxe-table /deep/ .vxe-cell {
    white-space: nowrap;
}
.dialog-input-text >>> .el-input__inner {
    height: 30px !important;
    width: 60% !important;
}
</style>
